<template>
  <div id="classificationPlan">
    <main role="main">
      <div class="container">
        <div class="row mb-5">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12 mb-4">
                <h2 class="d-inline">
                  {{ $t("text.classificationPlan.title") }}
                </h2>
                <router-link
                    :to="{ name: 'PremikanjeRazredov' }"
                    class="btn btn-primary btn-sm text-white float-right"
                ><i class="fas fa-mouse-pointer"></i> {{ $t("text.premikanjeRazredov.premestitevRazredovZgradivom") }}
                </router-link>
              </div>
            </div>

            <loading
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="true"
            ></loading>

            <div class="row" v-if="showConnectToAlfrescoErrorWarning">
              <div class="col-md-12 mt-2 mb-2">
                <div class="alert alert-danger">
                  <i class="fa fa-2x fa-exclamation-triangle d-block float-left mt-2 mr-3"></i>
                  {{ $t("text.classificationPlan.connectToAlfrescoErrorWarning") }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">

                <div class="classificationPlanEditor mb-5">
                  <!-- top buttons row -->
                  <div class="actionsContainer top">
                    <div class="actionItem">
                      <div
                          id="uploadButtonDiv"
                          class="file btn btn-sm btn-secondary"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.classificationPlanImport')"
                          v-if="
                          isClassificationPlanEmpty &&
                            $globalFunctions.checkForPermission(
                              'UVOZ_IZVOZ_KLASIF'
                            )
                        "
                      ><i class="fas fa-file-upload"></i> {{ $t("text.classificationPlan.import") }}
                        <input
                            @change="importClassificationPlan"
                            id="uploadButtonInput"
                            ref="files"
                            type="file"
                            name="file"
                        />
                      </div>

                      <div
                          id="additionalUploadButtonDiv"
                          class="file btn btn-sm btn-secondary"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.additionalClassificationPlanImport')"
                          v-if="
                          !isClassificationPlanEmpty &&
                            $globalFunctions.checkForPermission(
                              'UVOZ_IZVOZ_KLASIF'
                            )
                        "
                      >
                        <i class="fas fa-file-upload"></i> {{
                          $t("text.classificationPlan.import")
                        }}
                        <input
                            @change="importClassificationPlan"
                            id="additionalUploadButtonInput"
                            ref="files"
                            type="file"
                            name="file"
                        />
                      </div>
                    </div>

                    <div class="actionItem" v-if="classificationPlan.length > 0">
                      <button
                          id="exportButton1"
                          class="btn btn-sm btn-secondary"
                          @click="$bvModal.show('modal-export')"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.classificationPlanExport')"
                          v-if="
                          $globalFunctions.checkForPermission(
                            'UVOZ_IZVOZ_KLASIF'
                          )
                        "
                      >
                        <i class="fas fa-file-download"></i> {{ $t("text.globals.export") }}
                      </button>
                    </div>

                    <div class="actionItem">
                      <button
                          id="downloadButton1"
                          class="btn btn-sm btn-secondary"
                          @click="exportSampleClassificationPlan"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.sampleClassificationPlanExport')"
                          v-if="
                          $globalFunctions.checkForPermission(
                            'UVOZ_IZVOZ_KLASIF'
                          )
                        "
                      >
                        <i class="fas fa-download"></i> {{
                          $t("text.classificationPlan.sampleExport")
                        }}
                      </button>
                    </div>

                    <div class="actionItem" v-if="classificationPlan.length > 0">
                      <!--                                            <button id="moveButton1" class="btn btn-sm btn-secondary"-->
                      <!--                                                    @click="moveClassInClassificationPlan"-->
                      <!--                                                    v-b-tooltip.hover title="Premestitev razredov"-->
                      <!--                                                    v-if="$globalFunctions.checkForPermission('PREMESTI_RAZRED')"><i-->
                      <!--                                                    class="fas fa-mouse-pointer"></i>-->
                      <!--                                                {{$t('text.classificationPlan.move')}}-->
                      <!--                                            </button>-->

                      <b-dropdown
                          id="moveButton1"
                          size="sm"
                          type="secondary"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.moveClass.title')"
                          v-if="$globalFunctions.checkForPermission('PREMESTI_RAZRED')"
                      >
                        <template v-slot:button-content>
                          <i class="fas fa-mouse-pointer"></i> {{
                            $t("text.classificationPlan.move")
                          }}
                        </template>

                        <b-dropdown-item @click="moveClassInClassificationPlan"
                        >{{ $t("text.classificationPlan.tooltips.moveClass.dragAndDropMove") }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="moveClassByParentSelect"
                        >
                          {{ $t("text.classificationPlan.tooltips.moveClass.parentClassChooseMove") }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>

                    <div class="actionItem" v-if="classificationPlan.length > 0">
                      <button
                          id="searchButton1"
                          class="btn btn-sm btn-secondary"
                          @click="reviewClassificationPlan"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.reviewClass')"
                      >
                        <i class="fas fa-eye"></i> {{
                          $t("text.classificationPlan.viewAndSearch")
                        }}
                      </button>
                    </div>

                    <div class="actionItem" v-if="classificationPlan.length > 0">
                      <button
                          id="printButton1"
                          class="btn btn-sm btn-secondary"
                          @click="$bvModal.show('modal-print')"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.print')"
                          v-if="
                          $globalFunctions.checkForPermission('TISKANJE_KLASIF')"
                      >
                        <i class="fas fa-print"></i> {{ $t("text.classificationPlan.print") }}
                      </button>
                    </div>

                    <div class="actionItem" v-if="classificationPlan.length > 0">
                      <button
                          id="reportsButton1"
                          class="btn btn-sm btn-secondary"
                          @click="() => { $root.$emit('checkAll', false);  $bvModal.show('modal-reports'); }"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.reports')"
                          v-if="
                          $globalFunctions.checkForPermission(
                            'POROCILO_ENOTE_GRADIVA'
                          )
                        "
                      >
                        <i class="far fa-file-alt"></i> {{
                          $t("text.classificationPlan.reports")
                        }}
                      </button>
                    </div>

                    <div class="actionItem" v-if="classificationPlan.length > 0">
                      <button
                          id="reportsButton2"
                          class="btn btn-sm btn-secondary"
                          @click="$bvModal.show('modal-exportStorageDates')"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.exportStorageDates')"
                          v-if="$globalFunctions.checkForPermission('IZVOZ_ROKOV')">
                        <i class="fas fa-file-export"></i> {{
                          $t("text.classificationPlan.exportStorageDates")
                        }}
                      </button>
                    </div>

                    <div class="actionItem" v-if="classificationPlan.length > 0">
                      <button
                          id="toggleCollapse"
                          class="btn btn-sm btn-secondary"
                          @click="toggleCollapseAll(false)"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.toggleClassCollapse')"
                      >
                        <span v-if="collapsed"
                        ><i class="fas fa-expand-alt"></i> {{ $t("text.classificationPlan.expandAll") }}</span
                        ><span v-if="!collapsed"
                      ><i class="fas fa-compress-alt"></i
                      > {{ $t("text.classificationPlan.minimizeAll") }}</span
                      >
                      </button>
                    </div>

                    <div class="clearfix"></div>
                  </div>

                  <!-- the main tree structure -->
                  <div
                      class="bg-light p-3 classificationPlanTreeStructureContainer"
                  >

                    <div v-if="classificationPlan.length === 0">
                      <em
                      ><i class="fa fa-exclamation-triangle"></i
                      > {{
                          $t(
                              "text.globals.classificationPlanNotDefined"
                          )
                        }}</em
                      >
                    </div>

                    <TreeStructure
                        id="treeStructure1"
                        @select-item="selectItem"
                        :selectedClassLabel="selectedClassLabel"
                        :classificationPlan="_getClassificationPlan"
                        :printMode="false"
                        :showPopover="true"
                        :showErrors="true"
                        :selectable="true"
                    ></TreeStructure>

                    <div
                        v-if="hasClassificationPlanBeenChanged"
                        class="alert alert-warning py-0  mt-3 mb-1"
                    >
                      <small
                      ><i class="fa fa-exclamation-triangle"></i
                      > {{
                          $t("text.classificationPlan.localChangesMessage")
                        }}</small
                      >
                    </div>
                  </div>

                  <!-- the bottom buttons row -->
                  <div class="actionsContainer bottom">
                    <div class="selectedClass">
                      <span class="d-inline-block"
                      ><small>{{ $t("text.globals.selectedClass") }}:</small>
                        <b>{{
                            selectedClassLabel == "none"
                                ? "/"
                                : "(" +
                                selectedClassLabel +
                                ") " +
                                selectedClassLabelName
                          }}</b
                        ><span
                            class="alert alert-info pt-0 pb-0 ml-3"
                            v-if="selectedClassLabel == 'none'"
                        ><small>{{
                            $t("text.classificationPlan.chooseClass")
                          }}</small></span
                        ></span
                      >
                    </div>

                    <div class="actionItem">
                      <button
                          id="addClass1"
                          class="btn btn-sm btn-secondary"
                          @click="addClassificationPlanEntry"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.addChildClass')"
                          v-if="
                          $globalFunctions.checkForPermission('UREJANJE_KLASIF')
                        "
                      >
                        <i class="fas fa-plus-square"></i> {{
                          $t("text.classificationPlan.addClass")
                        }}
                      </button>
                    </div>

                    <div
                        class="actionItem"
                        v-if="
                        selectedClassLabel !== 'none' &&
                          $globalFunctions.checkForPermission('UREJANJE_KLASIF')
                      "
                    >
                      <button
                          id="editButton1"
                          class="btn btn-sm btn-secondary"
                          @click="editClassificationPlanEntry"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.editClass')"
                      >
                        <i class="fas fa-edit"></i> {{
                          $t("text.classificationPlan.editClass")
                        }}
                      </button>
                    </div>

                    <div
                        class="actionItem"
                        v-if="
                        selectedClassLabel !== 'none' &&
                          $globalFunctions.checkForPermission('UREJANJE_KLASIF')
                      "
                    >
                      <button
                          id="deleteButton1"
                          class="btn btn-sm btn-secondary"
                          @click="deleteClassificationPlanEntry"
                          v-b-tooltip.hover
                          :title="$t('text.classificationPlan.tooltips.deleteClass')"
                      >
                        <i class="fas fa-trash"></i> {{
                          $t("text.classificationPlan.deleteClass")
                        }}
                      </button>
                    </div>

                    <div class="clearfix"></div>
                  </div>
                </div>

                <b-button
                    id="cancelButton1"
                    v-if="hasClassificationPlanBeenChanged"
                    class="float-left"
                    variant="secondary"
                    @click="cancelClassificationPlanChanges()"
                >
                  {{ $t("text.globals.discardChanges") }}
                </b-button>

                <b-button
                    id="saveButton1"
                    class="float-right mr-0"
                    variant="primary"
                    @click="saveClassificationPlan"
                    v-if="$globalFunctions.checkForPermission('UREJANJE_KLASIF')"
                ><i class="fas fa-save"></i> {{ $t("text.globals.saveChanges") }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- all the modals on this page -->
    <div>
      <!-- ERRORS WHEN DISPATCHING TO BACKEND MODAL -->

      <b-modal
          centered
          size="lg"
          id="modal-classificationPlan-error"
          :title="$t('text.globals.error')"
      >
        <b-container>
          <b-row class="bg-light p-4">
            <b-col class="my-1">
              {{
                $t("text.classificationPlan.classificationPlanContainsErrors")
              }}

            </b-col>
          </b-row>
        </b-container>
        <div slot="modal-footer" class="w-100">
          <b-button
              id="previousButton1"
              class="float-right mr-0"
              @click="$bvModal.hide('modal-classificationPlan-error')"
          >{{ $t("text.globals.back") }}
          </b-button>
        </div>
      </b-modal>

      <!-- IMPORT MODALS -->

      <!-- the preview modal if we succesfully import the classification plan into the app -->

      <b-modal
          centered
          size="lg"
          id="modal-success"
          :title="$t('text.classificationPlan.importPreviewModalTitle')"
          :hide-header-close="true"
      >
        <b-container>
          <b-row class="p-4 bg-light">
            <b-col>
              <div class="alert alert-danger mt-2" v-if="errorMessages.length > 0">
                <h4>Napake:<br/></h4>
                <div v-for="(item, index) in errorMessages" class="mb-1">
                  <span v-if="errorMessages.length > 1" class="pr-1">{{ index + 1 }}.)</span> {{ item.message }}
                </div>
              </div>
              <TreeStructure
                  id="treeStructure2"
                  :classificationPlan="classificationPlanPreview"
                  :printMode="false"
                  :showPopover="true"
                  :showErrors="true"
                  :selectable="false">
              </TreeStructure>
            </b-col>
          </b-row>
        </b-container>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="cancelButton2"
              class="float-left"
              variant="secondary"
              @click="
              $bvModal.hide('modal-success');
              $refs.files.value = '';
            "
          >
            {{ $t("text.globals.cancel") }}
          </b-button>
          <b-button
              id="saveButton2"
              class="float-right mr-0"
              variant="primary"
              @click="
              $bvModal.hide('modal-success');
              dispatchPreviewedClassificationPlan();
            "
          >
            {{ $t("text.globals.accept") }}
          </b-button>
        </div>
      </b-modal>

      <!-- the error modal if we get an error while importing the classification plan into the app -->

      <b-modal
          centered
          size="lg"
          id="modal-error"
          :title="$t('text.classificationPlan.importErrorModalTitle')"
          :hide-header-close="true"
      >
        <b-container>
          <b-row class="p-4 bg-light">
            <b-col>
              <ul>
                <li
                    v-for="(error, index) in uploadErrors"
                    :key="'error_' + index"
                >
                  {{ error }}
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-container>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="previousButton2"
              variant="secondary"
              class="float-right mr-0"
              @click="$bvModal.hide('modal-error')"
          >
            {{ $t("text.globals.back") }}
          </b-button>
        </div>
      </b-modal>

      <b-modal
          centered
          size="lg"
          id="modal-error-move"
          :title="$t('text.classificationPlan.moveErrorModal.title')"
          :hide-header-close="true"
      >
        <b-container>
          {{ $t("text.classificationPlan.moveErrorModal.error") }}
        </b-container>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="previousButton3"
              variant="secondary"
              class="float-right mr-0"
              @click="$bvModal.hide('modal-error-move')"
          >
            {{ $t("text.globals.back") }}
          </b-button>
        </div>
      </b-modal>

      <b-modal
          centered
          size="lg"
          id="modal-moveReason"
          :title="$t('text.classificationPlan.moveReasonModal.title')"
          :hide-header-close="true"
          @hidden="resetReason()"
      >
        <b-container>
          <b-card no-body class=" mb-2">
            <b-card-header
                class="p-3"
                :class="showCollapse ? 'collapsed' : null"
                :aria-expanded="showCollapse ? 'true' : 'false'"
                aria-controls="collapse"
                @click="showCollapse = !showCollapse"
            >
              <div v-if="showCollapse">
                <span
                ><i class="fas fa-chevron-down"></i> {{
                    $t("text.classificationPlan.moveReasonModal.hidePreview")
                  }}</span
                >
              </div>
              <div v-else>
                <span
                ><i class="fas fa-chevron-right"></i> {{
                    $t("text.classificationPlan.moveReasonModal.showPreview")
                  }}</span
                >
              </div>
            </b-card-header>
            <b-collapse id="collapse" v-model="showCollapse">
              <b-card-body>
                <div
                    class="mb-3 bg-light p-3 classificationPlanTreeStructureContainer"
                >
                  <TreeStructure
                      id="treeStructure3"
                      :selectedClassLabel="
                      movingClass != null ? movingClass.classificationLabel : ''
                    "
                      :classificationPlan="movePreview"
                      :printMode="false"
                      :selectable="false"
                  ></TreeStructure>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
          <div class="form-group">
            <label for="moveReason">{{
                $t("text.classificationPlan.moveReasonModal.reason")
              }}</label>
            <textarea
                spellcheck="false"
                type="text"
                class="form-control"
                id="moveReason"
                aria-describedby="moveReason"
                name="moveReason"
                :class="{
                'is-invalid': moveReason === '' && reasonMissing === true
              }"
                v-model="moveReason"
            >
            </textarea>
            <div
                class="invalid-feedback"
                v-if="reasonMissing"
                style="font-size: 1rem"
            >
              {{ $t("text.classificationPlan.moveReasonModal.reasonNotGiven") }}
            </div>
          </div>
          <div class="form-group">
            <label for="classificationLabelName">{{
                $t(
                    "text.classificationPlan.moveReasonModal.newClassificationLabel"
                )
              }}</label>
            <input
                type="text"
                class="form-control"
                id="classificationLabelName"
                aria-describedby="classificationLabelName"
                name="classificationLabelName"
                :class="{
                'is-invalid':
                  moveClassificationLabel === '' ||
                  (moveParentLabel.length >= moveClassificationLabel.length &&
                    moveParentLabel !== 'none') ||
                  (!moveClassificationLabel.startsWith(moveParentLabel) &&
                    moveParentLabel !== 'none')
              }"
                v-model="moveClassificationLabel"
            />
            <div class="invalid-feedback" v-if="moveClassificationLabel === ''">
              {{
                $t(
                    "text.classificationPlan.moveReasonModal.newClassificationLabelNotGiven"
                )
              }}
            </div>
            <div
                class="invalid-feedback"
                v-else-if="
                (moveParentLabel.length >= moveClassificationLabel.length &&
                  moveParentLabel !== 'none' &&
                  moveClassificationLabel != '') ||
                  (!moveClassificationLabel.startsWith(moveParentLabel) &&
                    moveParentLabel !== 'none' &&
                    moveClassificationLabel != '')
              "
            >
              {{
                $t(
                    "text.classificationPlan.moveReasonModal.newClassificationLabelSyntaxError1"
                )
              }}
              {{ moveParentLabel }}
              {{
                $t(
                    "text.classificationPlan.moveReasonModal.newClassificationLabelSyntaxError2"
                )
              }}
            </div>
          </div>
        </b-container>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="previousButton4"
              variant="secondary"
              class="float-left mr-0"
              @click="$bvModal.hide('modal-moveReason')"
          >
            {{ $t("text.globals.back") }}
          </b-button>
          <b-button
              id="saveButton3"
              variant="primary"
              class="float-right mr-0"
              @click="validateMove()"
          >
            {{ $t("text.globals.accept") }}
          </b-button>
        </div>
      </b-modal>

      <!-- the modal we get if we are additionally appending a classification plan, we need to select the parent class to which we will append the new classification plan -->

      <b-modal
          centered
          size="lg"
          id="modal-append"
          :title="$t('text.classificationPlan.additionalAppendModal.title')"
          :hide-header-close="true"
      >
        <b-container>
          <b-row>
            <b-col>
              <div class="p-4 bg-light">
                <TreeStructure
                    id="treeStructure4"
                    @select-item="selectItem"
                    :selectedClassLabel="selectedClassLabel"
                    :classificationPlan="classificationPlan"
                    :printMode="false"
                    :showPopover="true"
                    :showErrors="true"
                    :selectable="true"
                >
                </TreeStructure>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="my-1">
              <div class="alert alert-info mt-2">
                <small>
                  {{
                    $t("text.classificationPlan.additionalAppendModal.info")
                  }}</small
                >
              </div>
            </b-col>
          </b-row>
        </b-container>
        <div slot="modal-footer" class="w-100">
          <b-button
              id="cancelButton3"
              class="float-left"
              variant="secondary"
              @click="$bvModal.hide('modal-append')"
          >
            {{ $t("text.globals.cancel") }}
          </b-button>
          <b-button
              id="continueButton1"
              class="float-right mr-0"
              variant="primary"
              @click="
              () => {
                $bvModal.hide('modal-append');
                appendToTree();
              }
            "
          >
            {{ $t("text.globals.continue") }}
          </b-button>
        </div>
      </b-modal>

      <!-- EXPORT MODAL -->

      <!--the modal we get to check fields we want export and to add filters before exporting-->

      <b-modal
          centered
          id="modal-export"
          size="lg"
          :title="$t('text.classificationPlan.exportModalTitle')"
          :hide-header-close="true"
      >
        <b-row class="bg-light">
          <b-col>
            <ClassificationPlanFilter
                :toExport="true"
                :id="filterKey1"
                :key="filterKey1"
            />
          </b-col>
        </b-row>
        <div slot="modal-footer" class="w-100">
          <b-button
              id="cancelButton4"
              class="float-left"
              variant="secondary"
              @click="$bvModal.hide('modal-export')"
          >
            {{ $t("text.globals.cancel") }}
          </b-button>
          <b-button
              id="exportButton2"
              class="float-right mr-0"
              variant="primary"
              @click="
              () => {
                exportClassificationPlan();
                $bvModal.hide('modal-export');
              }
            "
          >
            {{ $t("text.globals.export") }}
          </b-button>
        </div>
      </b-modal>

      <!-- MOVE MODAL -->

      <!-- the modal for moving classes inside the classification plan -->

      <b-modal
          centered
          id="modal-move"
          :title="$t('text.classificationPlan.moveModal.title')"
          size="lg"
          :hide-header-close="true"
      >
        <b-row class="bg-light" style="overflow-y: auto;">
          <b-col>
            <div
                v-if="classificationPlan.length > 0"
                draggable="false"
                style="margin-left: 2%; font-weight: 700"
                @drop="dropRoot"
                @dragover="dragoverRoot"
                @dragleave="dragleaveRoot"
                :class="draggedOver ? 'dragContainer over' : 'dragContainer'"
            >
              {{ $t("text.classificationPlan.rootClass") }}
            </div>
            <div
                v-else
                style="margin-top: 2%; display: inline-block;"
                class="alert alert-warning"
                role="alert"
            >
              {{ $t("text.classificationPlan.moveModal.noClassificationPlan") }}
            </div>
            <TreeStructure
                id="treeStructure5"
                :checked="false"
                :classification-plan="classificationPlan"
                :move="true"
                :printMode="false"
                :showPopover="true"
                :showErrors="true"
                :selectable="false"
            ></TreeStructure>
          </b-col>
        </b-row>
        <div slot="modal-footer" class="w-100">
          <b-button
              id="cancelButton5"
              class="float-left"
              variant="secondary"
              @click="
              $bvModal.hide('modal-move');
              cancelMove();
            "
          >
            {{ $t("text.globals.cancel") }}
          </b-button>
          <b-button
              id="saveButton4"
              class="float-right mr-0"
              variant="primary"
              @click="() => { $bvModal.hide('modal-move', 'default'); $store.dispatch('setMoves', moves);}">
            {{ $t("text.globals.save") }}
          </b-button>
        </div>
      </b-modal>

      <b-modal
          centered
          size="lg"
          id="modal-moveToRoot"
          :title="$t('text.classificationPlan.moveReasonModal.title')"
          :hide-header-close="true"
          @hidden="resetReason()"
      >
        <b-container>
          <b-card no-body class=" mb-2">
            <b-card-header
                class="p-3"
                :class="showCollapse ? 'collapsed' : null"
                :aria-expanded="showCollapse ? 'true' : 'false'"
                aria-controls="collapse1"
                @click="showCollapse = !showCollapse"
            >
              <div v-if="showCollapse">
                <span
                ><i class="fas fa-chevron-down"></i
                > {{
                    $t("text.classificationPlan.moveReasonModal.hidePreview")
                  }}</span
                >
              </div>
              <div v-else>
                <span
                ><i class="fas fa-chevron-right"></i
                > {{
                    $t("text.classificationPlan.moveReasonModal.showPreview")
                  }}</span
                >
              </div>
            </b-card-header>
            <b-collapse id="collapse1" v-model="showCollapse">
              <b-card-body>
                <div
                    class="mb-3 bg-light p-3 classificationPlanTreeStructureContainer"
                >
                  <TreeStructure
                      id="treeStructure6"
                      :selectedClassLabel="
                      movingClass != null ? movingClass.classificationLabel : ''"
                      :selectable="false"
                      :classificationPlan="movePreview"
                      :printMode="false"
                  ></TreeStructure>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
          <div class="form-group">
            <label for="moveReason1">
              {{ $t("text.classificationPlan.moveReasonModal.reason") }}</label
            >
            <textarea
                spellcheck="false"
                type="text"
                class="form-control"
                id="moveReason1"
                aria-describedby="moveReason1"
                name="moveReason1"
                :class="{
                'is-invalid': moveReason === '' && reasonMissing === true
              }"
                v-model="moveReason"
            >
            </textarea>
            <div
                class="invalid-feedback"
                v-if="reasonMissing"
                style="font-size: 1rem"
            >
              {{ $t("text.classificationPlan.moveReasonModal.reasonNotGiven") }}
            </div>
          </div>
          <div class="form-group">
            <label for="classificationLabelName">{{
                $t(
                    "text.classificationPlan.moveReasonModal.newClassificationLabel"
                )
              }}</label>
            <input
                type="text"
                class="form-control"
                id="classificationLabelName1"
                aria-describedby="classificationLabelName"
                name="classificationLabelName"
                :class="{ 'is-invalid': moveClassificationLabel === '' }"
                v-model="moveClassificationLabel"
            />
            <div class="invalid-feedback" v-if="moveClassificationLabel === ''">
              {{
                $t(
                    "text.classificationPlan.moveReasonModal.newClassificationLabelNotGiven"
                )
              }}
            </div>
          </div>
        </b-container>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="previousButton5"
              variant="secondary"
              class="float-left mr-0"
              @click="$bvModal.hide('modal-moveToRoot')"
          >
            {{ $t("text.globals.back") }}
          </b-button>
          <b-button
              id="saveButton5"
              variant="primary"
              class="float-right mr-0"
              @click="validateMoveToRoot()"
          >
            {{ $t("text.globals.accept") }}
          </b-button>
        </div>
      </b-modal>

      <!-- PRINT MODAL -->

      <!-- the modal we get to check fields we want to print  and to add filters before printing -->

      <b-modal
          centered
          id="modal-print"
          :title="$t('text.classificationPlan.printModalTitle')"
          size="lg"
          :hide-header-close="true"
      >
        <b-row class="bg-light">
          <b-col>
            <ClassificationPlanFilter
                :toPrint="true"
                :id="filterKey2"
                :key="filterKey2"
            />
          </b-col>
        </b-row>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="previousButton6"
              class="float-left"
              variant="secondary"
              @click="$bvModal.hide('modal-print')"
          >
            {{ $t("text.globals.cancel") }}
          </b-button>
          <b-button
              id="printButton2"
              class="float-right mr-0"
              variant="primary"
              @click="
              printClassificationPlan();
              $bvModal.hide('modal-print');
            "
          >
            {{ $t("text.classificationPlan.print") }}
          </b-button>
        </div>
      </b-modal>

      <b-modal
          centered
          id="modal-selectParentClass"
          :title="
        $t('text.classificationPlan.selectParentClassModal.title') + ' (' +
            selectedClassLabel +
            ') ' +
            selectedClassLabelName
        "
          size="lg"
          :hide-header-close="true"
      >
        <b-row>
          <b-col class="mb-3">
            {{ $t('text.classificationPlan.selectParentClassModal.selectNewParentClass') }}
            <b>({{ selectedClassLabel }}) {{ selectedClassLabelName }}</b
            >:
          </b-col>
        </b-row>

        <b-row>
          <b-col class="mb-3">
            <v-select
                class="form-control"
                :options="_getClassificationPlanWithRoot"
                v-model="newParentClass"
                :reduce="item => item.classificationLabel"
                :filter-by="knSearchFilter"
                label="classificationLabelName"
            >
              <span slot="no-options">{{ $t("text.globals.noOptions") }}</span>

              <template slot="option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'"
                >({{ option.classificationLabel }})</span
                >
                {{ option.classificationLabelName }}
              </template>
              <template slot="selected-option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'"
                >({{ option.classificationLabel }})</span
                >
                {{ option.classificationLabelName }}
              </template>
            </v-select>
          </b-col>
        </b-row>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="cancelBtn"
              variant="secondary"
              class="float-left mr-0"
              @click="
              () => {
                newParentClass = null;
                $bvModal.hide('modal-selectParentClass');
              }
            "
          >
            {{ $t("text.globals.cancel") }}
          </b-button>
          <b-button
              id="confirmMove"
              variant="primary"
              class="float-right mr-0"
              @click="confirmMoveCall"
          >
            {{ $t("text.globals.accept") }}
          </b-button>
        </div>
      </b-modal>

      <b-modal
          centered
          id="modal-reports"
          :title="$t('text.classificationPlan.reports')"
          size="lg"
          :hide-header-close="true"
      >
        <b-row class="bg-light">
          <b-col>
            <ClassificationPlanFilter
                :toPrint="true"
                :id="filterKey2"
                :key="filterKey2"
                ref="filterKey2"
            />
          </b-col>
        </b-row>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="previousButton6_2"
              class="float-left"
              variant="secondary"
              @click="() => { $bvModal.hide('modal-reports'); $refs['filterKey2'].clearAllFilters(); }"
          >
            {{ $t("text.globals.cancel") }}
          </b-button>

          <div
              v-for="(item, index) in reportTypeOptions"
              :key="item.reportType"
          >
            <b-button
                :id="'reportsButton' + (index + 2)"
                class="float-right mr-0"
                variant="primary"
                @click="
                e => {
                  generateReport(item.reportType);
                }
              "
            >
              {{ item.name }}
            </b-button>
          </div>
        </div>
      </b-modal>

      <b-modal
          centered
          id="modal-exportStorageDates"
          :title="$t('text.classificationPlan.exportStorageDates')"
          size="lg"
          :hide-header-close="true"
      >
        <b-row class="bg-light">
          <b-col>
            <ClassificationPlanFilter
                :toPrint="true"
                :id="filterKey2"
                :key="filterKey2"
            />
          </b-col>
        </b-row>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="previousButton6_2"
              class="float-left"
              variant="secondary"
              @click="() => {$bvModal.hide('modal-exportStorageDates');}"
          >
            {{ $t("text.globals.cancel") }}
          </b-button>


          <b-button
              id="exportStorageDatesBtn"
              class="float-right mr-0"
              variant="primary"
              @click="
                e => {
                  exportStorageDates();
                  $bvModal.hide('modal-exportStorageDates');
                  $refs['filterKey2'].clearAllFilters();
                }
              "
          >
            {{ $t('text.classificationPlan.exportStorageDates') }}
          </b-button>

        </div>
      </b-modal>


      <b-modal
          centered
          size="lg"
          id="modal-duplicates-error"
          :title="$t('text.globals.error')"
          :hide-header-close="true"
      >
        <b-row class="bg-light p-4">
          <b-col class="my-1">
            {{ $t("text.classificationPlan.duplicateClassesMessage") }}
          </b-col>
        </b-row>
        <div slot="modal-footer" class="w-100">
          <b-button
              id="previousButton7"
              class="float-right mr-0"
              @click="$bvModal.hide('modal-duplicates-error')"
          >
            {{ $t("text.globals.back") }}
          </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script type="text/javascript">
import Vue from "vue";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faHome} from "@fortawesome/free-solid-svg-icons";
import SidebarNavigation from "../components/SidebarNavigation";
import {VueGoodTable} from "vue-good-table";
import axios from "axios/index";
import TreeStructure from "../components/TreeStructure";
import convert from "xml-js";
import ClassificationPlanFilter from "../components/ClassificationPlanFilter";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import flatten from 'flat';

library.add(faHome);

export default {
  name: "ClassificationPlan",
  components: {
    ClassificationPlanFilter,
    SidebarNavigation,
    TreeStructure,
    convert,
    Loading,
    vSelect
  },
  data() {
    return {
      vpisniki: [],
      povezaniSistemi: [],
      rokHrambe: [],
      vrstaGradiva: [],
      filteredVpisniki: [],
      selectedClass: null,
      selectedClassLabel: "none",
      selectedClassLabelName: "",
      uploadErrors: [],
      classificationPlanPreview: [],
      classificationPlanToAppend: [],
      classificationPlanDuplicatesCheckArray: [],
      classificationPlanPrint: [],
      classificationPlan: this.$store.getters.getClassificationPlan,

      //todo: popravi setanje, tudi ce ne uporabimo filtra
      classificationPlanExport: this.classificationPlan,
      movingClass: null,
      arr: [],
      filterKey1: 0,
      filterKey2: 1,
      classificationPlanLabels: [],
      classificationPlanCopy: [],
      movePayload: null, // payload we need for moveClass, event listener for event "drop" sets it
      moveReason: "",
      moveClassificationLabel: "",
      moveClassificationlabelIncorrect: false,
      moveParentLabel: "",
      reasonMissing: false,
      moves: [],
      movesCopy: [],
      isLoading: true,
      movePreview: [],
      showCollapse: false,
      locallyDeletedClasses: false,

      draggedOver: false,
      collapsed: true,

      reportTypeOptions: [],

      newParentClass: null,
      expandAll: this.$route.params.expandAll,
      ccUpdated: this.$route.params.ccUpdated,

      errorMessages: [],
      showConnectToAlfrescoErrorWarning: false,
      selectParentClassModalVisible: false,
      knSearchFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.classificationLabel.toLowerCase().indexOf(temp) > -1 ||
            option.classificationLabelName.toLowerCase().indexOf(temp) > -1
      }
    };
  },
  created() {
    // window.addEventListener("beforeunload", function(e){
    //     e.returnValue = "Ste prepričani, da želite zapustiti stran? Spremembe, ki ste jih naredili ne bodo shranjene.";
    // });
  },

  mounted() {
    const _this = this;

    console.log("Mounted!");

    this.$store.dispatch("retrieveAllDropdownOptions").then(() => {
      this.vpisniki = this.$store.getters.getRegisterOptions;

      let ehrambaPovezaniSistemi = [];
      _.each(this.$store.getters.getConnectedSystemsOptions, function (innerItem) {
        if (innerItem.ehramba) {
          ehrambaPovezaniSistemi.push(innerItem);
        }
      });
      this.povezaniSistemi = ehrambaPovezaniSistemi;

      this.rokHrambe = this.$store.getters.getStorageDateOptions;
      this.vrstaGradiva = this.$store.getters.getDocumentTypeOptions;


      setTimeout(() => {
        this.getClassificationPlan({shouldUpdateStore: this.ccUpdated ? false : true});
        //on mount we get the classification plan from the store

        this.classificationPlan = this.$store.getters.getClassificationPlan;
      }, 100);

    });

    let p1 = this.$store.dispatch("retrieveReportTypeOptions",);

    Promise.all([p1]).then(() => {
      this.reportTypeOptions = _.filter(
          this.$store.getters.getReportTypeOptions,
          {guiLocation: "KN_IZBOR"}
      );

      if (this.expandAll) {
        this.toggleCollapseAll(true);
      }
    });


    //root event listeners

    //drop on drag and drop move feature

    this.$root.$on("drop", payload => {
      console.log("payload", payload);
      this.movingClass = payload[1];
      this.moveParentLabel = payload[0].classificationLabel;

      this.moveClassificationLabel = this.movingClass.classificationLabel;

      this.movePayload = payload;
      this.movesCopy = _.cloneDeep(this.moves);
      console.log(
          "move",
          this.movingClass.parentClass === payload[0].classificationLabel,
          this.movingClass.classificationLabel === payload[0].classificationLabel,
          this.checkMove(payload[0], this.movingClass)
      );

      if (
          this.movingClass.classificationLabel !== payload[0].classificationLabel
      ) {
        if (
            this.movingClass.parentClass === payload[0].classificationLabel ||
            this.movingClass.classificationLabel ===
            payload[0].classificationLabel ||
            this.checkMove(payload[0], this.movingClass) === false
        ) {
          this.$bvModal.show("modal-error-move");
        } else {
          if (this.movingClass.containsRecords) {
            console.log("contains records");

            // if (this.$globalFunctions.checkUserRole("ALFRESCO_ADMIN")) {
            //     this.$swal({
            //         title: this.$t('text.globals.warningTitle'),
            //         text: this.$t(
            //             "text.classificationPlan.movingClassContainsRecordsSwal.content"
            //         ),
            //         dangerMode: true,
            //         buttons: {
            //             cancel: {
            //                 text: this.$t("text.globals.cancel"),
            //                 value: null,
            //                 visible: true,
            //                 className: "",
            //                 closeModal: true
            //             },
            //             confirm: {
            //                 text: this.$t(
            //                     "text.globals.move"
            //                 ),
            //                 value: true,
            //                 visible: true,
            //                 className: "",
            //                 closeModal: true
            //             }
            //         }
            //     }).then(value => {
            //         switch (value) {
            //             case true:
            //                 console.log(
            //                     this.movingClass.classificationLabel,
            //                     payload[0].classificationLabel,
            //                     this.checkMove(payload[0], this.movingClass)
            //                 );
            //                 this.makeMovePreview(payload);
            //                 this.$bvModal.show("modal-moveReason");
            //
            //             case null:
            //                 return;
            //
            //                 break;
            //
            //             default:
            //         }
            //     });
            // } else {
            this.$swal(
                this.$t('text.globals.error'),
                this.$t(
                    "text.classificationPlan.movingClassContainsRecordsNoAdminErrorSwal.content"
                ),
                "error",
                {dangerMode: true}
            );
            // }
          } else {
            console.log(
                this.movingClass.classificationLabel,
                payload[0].classificationLabel,
                this.checkMove(payload[0], this.movingClass)
            );
            this.makeMovePreview(payload);
            this.$bvModal.show("modal-moveReason");
          }
        }
      }
    });

    //this.moveClass(payload);

    this.$root.$on("move", item => {
      this.movingClass = item;
    });

    this.$root.$on("changeThis", item => {
      this.changeThis(item);
    });

    this.$root.$on("checkAll", checked => {
      console.log("checkAll caught");
      this.checkAll(checked)
    });

    this.$root.$on("setClassificationPlanExport", item => {
      this.classificationPlanExport = item;
    });

    this.$root.$on("setClassificationPlanPrint", item => {
      this.classificationPlanPrint = item;
    });

    this.$root.$on("updateFilter", key => {
      if (key === this.filterKey1) {
        this.filterKey2++;
      } else {
        this.filterKey1++;
      }
    });

    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      console.log(bvEvent.trigger);
      if (modalId === "modal-move") {
        if (bvEvent.trigger === "backdrop") {
          this.cancelMove();
        }
      }

      if (this.$refs.files) {
        this.$refs.files.value = "";
      }
    });
  },

  beforeDestroy() {
    this.$root.$off("changeThis");

    console.log("destroy");
    //window.removeEventListener("beforeunload", function() {});
  },

  beforeRouteLeave(to, from, next) {
    const _this = this;

    if (this.hasClassificationPlanBeenChanged) {
      console.log("to.name -> ", to.name);
      let toPathName = to.name.toLowerCase();
      console.log("toPathName -> ", toPathName);
      if (toPathName.includes("classificationplan")) {
        next();
      } else {
        //next(false);

        this.$swal({
          title: this.$t('text.globals.warningTitle'),
          text: this.$t(
              "text.classificationPlan.closeLocallyChangedClassificationPlanSwal.content"
          ),
          dangerMode: true,
          icon: "warning",
          buttons: {
            cancel: {
              text: this.$t("text.globals.cancel"),
              value: null,
              visible: true,
              className: "",
              closeModal: true
            },
            confirm: {
              text: this.$t(
                  "text.classificationPlan.closeLocallyChangedClassificationPlanSwal.leavePage"
              ),
              value: true,
              visible: true,
              className: "",
              closeModal: true
            }
          }
        }).then(value => {
          switch (value) {
            case true:
              _this.getClassificationPlan({shouldUpdateStore: true});
              _this.isLoading = true;

              setTimeout(function () {
                next();
              }, 100);

            case null:
              next(false);

              break;

            default:
          }
        });
      }
    } else {
      next();
    }
  },

  computed: {
    _getClassificationPlan() {
      return this.$store.getters.getClassificationPlan;
    },

    isClassificationPlanEmpty() {
      return this.classificationPlan.length === 0;
    },

    hasClassificationPlanBeenChanged() {
      return (
          this.checkIfThereAreAnyChangedClasses() || this.locallyDeletedClasses
      );
    },

    _getClassificationPlanWithRoot() {
      if (!this.selectParentClassModalVisible) {
        return [];

      } else {

        let classificationPlan = _.cloneDeep(
            this.$store.getters.getClassificationPlan
        );

        classificationPlan.unshift({
          alfrescoId: null,
          classificationLabel: "none",
          containsRecords: false,
          classificationLabelName: "Korenski načrt",
          classificationLabelDescription: "Korenski načrt",
          duplicatedClassLabels: [],
          rokHrambe: [],
          vpisnik: [],
          povezaniSistemi: [],
          usageEndDate: null,
          creationDate: null,
          parentClass: null,
          item: [],
          errors: {},
          structure: {
            isOpen: true,
            checked: true,
            depth: 1,
            changed: false,
            match: false
          }
        });


        let flattenClassificationPlan = flatten(classificationPlan);
        let classificationPlanToReturn = [];

        // retrieve classificationLabel & classificationLabelName from flatenned classificationPlan
        _.map(flattenClassificationPlan, function (val, key, idx) {
          if (key.indexOf('classificationLabelName') > -1) {
            let index = 0;
            let objIndex = Object.keys(flattenClassificationPlan).indexOf(key);

            if ((Object.keys(flattenClassificationPlan)[objIndex - 2].indexOf('classificationLabel') > -1) && (typeof val === 'string')) {
              let item = {
                classificationLabelName: val,
                classificationLabel: flattenClassificationPlan[Object.keys(flattenClassificationPlan)[objIndex - 2]],
              }
              classificationPlanToReturn.push(item);
            }
          }
        });

        console.log("classificationPlanToReturn", classificationPlanToReturn);
        return classificationPlanToReturn;

      }
    }
  },

  watch: {
    classificationPlan: function () {
      this.updateFilterKeys();
    }
  },

  methods: {
    saveClassificationPlan() {
      const _this = this;
      this.isLoading = true;

      if (this.checkFieldValidity(this.classificationPlan)) {
        let currentClassificationPlan = this.checkClassificationPlanForExport();

        console.log("this.classificationPlan", this.classificationPlan);

        let modifiedUuids = [];

        _.filterDeep(
            this.classificationPlan,
            (value, key, parent, filterObject) => {
              if (key == 'changed' && value == true) {
                if (filterObject._item.parentItem.parentItem.value.alfrescoId) {
                  modifiedUuids.push(filterObject._item.parentItem.parentItem.value.alfrescoId);
                }
              }
            }
        );


        let currentSessionHash = this.$store.getters
            .getClassificationPlanSessionHash;

        // ker se array kot root element ne bo pravilno sparsal v xml, moramo okoli njega dodati root objekt
        // we need to put a root object around our classification plan, so the parser returns the correct xml
        let classificationPlanPlusRoot = {
          root: {
            meta: {
              hash: currentSessionHash,
              updated: modifiedUuids.length > 0 ? modifiedUuids.join(',') : '',
              deleted: _this.$store.getters.getClassificationPlanDeletedClasses.length > 0 ? _this.$store.getters.getClassificationPlanDeletedClasses.join(',') : ''
            },
            item: currentClassificationPlan
          }
        };

        // options za pretvarjanje js2xml
        // parser options object
        const options = {compact: true, spaces: 4};

        // pretvorimo objekt v xml
        // converting the object to xml
        let classificationPlanXML = convert.js2xml(
            classificationPlanPlusRoot,
            options
        );

        let headersConfig = {
          headers: {"Content-Type": "text/xml"}
        };

        let dataForPost =
            '<?xml version="1.0" encoding="UTF-8"?>\n' + classificationPlanXML;
        console.log(dataForPost);

        axios
            .post(
                config.alfrescoServiceApi + "rma/admin/ehramba/fileplan",
                dataForPost,
                headersConfig
            )
            .then(res => {
              _this.ccUpdated = false;

              console.log("success", res);
              this.getClassificationPlan({shouldUpdateStore: true});

              console.log("MOVES!!!", _this.$store.getters.getMoves);

              let moveReasons = [];
              _.each(_this.$store.getters.getMoves, function (val, key) {
                console.log("_this.$store.getters.getMoves item ->", val);
                if (val.uuid) {
                  moveReasons.push({
                    "beforeLabel": val.oldClassificationLabel,
                    "afterLabel": val.newClassificationLabel,
                    "reason": val.reason,
                    "uuid": val.uuid
                  });
                }
              });

              console.log("moveReasons", moveReasons);

              axios
                  .post(config.alfrescoServiceApi + "rma/admin/ehramba/filePlanReason", {"items": moveReasons})
                  .then(res => {
                    _this.moves = [];
                    _this.movesCopy = [];
                    _this.$store.dispatch('clearClassificationPlanDeletedClass');
                    _this.$store.dispatch('setMoves', []);

                    Vue.$toast.open({
                      message: this.$t(
                          "text.classificationPlan.classificationPlanSuccessfullySavedToast"
                      ),
                      type: "success",
                      position: "top-right"
                    });
                  });


            })
            .catch(error => {
              console.error(error);

              if (error.response.status === 409) {
                this.$swal({
                  title: this.$t(
                      "text.classificationPlan.locallyChangedClassificationPlanSaveErrorSwal.title"
                  ),
                  text: this.$t(
                      "text.classificationPlan.locallyChangedClassificationPlanSaveErrorSwal.content"
                  ),
                  dangerMode: true,
                  buttons: {
                    cancel: {
                      text: this.$t("text.globals.cancel"),
                      value: null,
                      visible: true,
                      className: "",
                      closeModal: true
                    },
                    confirm: {
                      text: this.$t("text.globals.discardChanges"),
                      value: true,
                      visible: true,
                      className: "",
                      closeModal: true
                    }
                  }
                }).then(value => {
                  switch (value) {
                    case true:
                      this.cancelClassificationPlanChanges();

                    case null:
                      return;

                      break;

                    default:
                  }
                });
              } else {
                Vue.$toast.open({
                  message: this.$t(
                      "text.classificationPlan.classificationPlanSaveErrorToast"
                  ),
                  type: "error",
                  position: "top-right"
                });
              }

              this.isLoading = false;
            });
      } else {
        console.log("napake v klasifikacijskem načrtu.");
        console.log(this.classificationPlan.errors);
        this.$bvModal.show("modal-classificationPlan-error");
        this.isLoading = false;
      }
    },

    getClassificationPlan(params) {
      const _this = this;

      axios
          .get(config.alfrescoServiceApi + "rma/admin/ehramba/fileplan")
          .then(res => {
            //console.log(res);

            if (this.isClassificationPlanEmpty || params.shouldUpdateStore) {
              console.log(
                  "klasisfikacijskega načrta v storu še ni, naložimo načrt z backenda"
              );

              _this.$store.dispatch('clearClassificationPlanDeletedClass');

              let options = {
                compact: true
              };

              this.locallyDeletedClasses = false;

              let classificationPlanJs = convert.xml2js(res.data, options);

              this.$store.dispatch(
                  "setClassificationPlanSessionHash",
                  classificationPlanJs.root.meta.hash._text
              );

              // console.log("---->", classificationPlanJs.root.meta.hash._text);
              //
              // console.log(
              //     "session hash: ",
              //     this.$store.getters.getClassificationPlanSessionHash
              // );

              this.classificationPlan = this.formatObject(
                  classificationPlanJs,
                  "fromServer"
              );

              this.checkFieldValidity(this.classificationPlan);

              for (let i = 0; i < _this.classificationPlan.length; i++) {
                _this.classificationPlan[i].structure.isOpen = false;
              }

              this.$store.dispatch(
                  "setClassificationPlan",
                  this.classificationPlan
              );
              this.$store.dispatch(
                  "setClassificationPlanFiltered",
                  this.classificationPlan
              );
              this.classificationPlan = this.$store.getters.getClassificationPlan;

              if (this.expandAll) {
                this.toggleCollapseAll(true);
              }

              _this.showConnectToAlfrescoErrorWarning = false;
              this.isLoading = false;

            } else {
              console.log("klasifikacijski načrt že obstaja v storu");
              _this.showConnectToAlfrescoErrorWarning = false;
              this.isLoading = false;
            }
          })
          .catch(error => {
            console.error(error);

            _this.showConnectToAlfrescoErrorWarning = true;

            this.isLoading = false;
          });
    },

    cancelClassificationPlanChanges() {
      this.$swal({
        title: this.$t(
            "text.classificationPlan.cancelLocalClassificationPlanChangesSwal.title"
        ),
        text: this.$t(
            "text.classificationPlan.cancelLocalClassificationPlanChangesSwal.content"
        ),
        dangerMode: true,
        buttons: {
          cancel: {
            text: this.$t("text.globals.back"),
            visible: true,
            className: "",
            closeModal: true
          },
          confirm: {
            text: this.$t("text.globals.continue"),
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        }
      }).then(value => {
        switch (value) {
          case true:
            this.isLoading = true;
            this.ccUpdated = false;
            this.$store.dispatch('clearClassificationPlanDeletedClass');
            this.getClassificationPlan({shouldUpdateStore: true});

          case null:
            return;

            break;

          default:
        }
      });
    },

    updateFilterKeys() {
      this.filterKey1++;
      this.filterKey2++;
    },

    checkIfThereAreAnyChangedClasses() {
      for (let i = 0; i < this.classificationPlan.length; i++) {
        if (
            this.checkIfThereAreAnyChangedClassesRec(this.classificationPlan[i])
        ) {
          return true;
        }
      }
      return false;
    },
    checkIfThereAreAnyChangedClassesRec(classificationPlan) {
      if (classificationPlan.structure.changed === true) {
        return true;
      }

      for (let i = 0; i < classificationPlan.item.length; i++) {
        if (
            this.checkIfThereAreAnyChangedClassesRec(classificationPlan.item[i])
        ) {
          return true;
        }
      }
      return false;
    },

    // ko v enem izmed tree itemov izberemo razred, nastavimo data spremenljivko izbrani razred (selectedClassLabel) izbrani razred lahko urejamo, brišemo, zapremo, ali pa mu dodajamo podrejene razrede
    // when we select a class in one of the treeItems, we set a selectedClasslabel variable to the selected class' label
    selectItem(item) {
      console.log("izbran razred: ", item.classificationLabel);
      if (this.selectedClassLabel === item.classificationLabel) {
        this.selectedClassLabel = "none";
        this.selectedClassLabelName = "";
        this.selectedClass = null;
      } else {
        this.selectedClassLabel = item.classificationLabel;
        this.selectedClassLabelName = item.classificationLabelName;
        this.selectedClass = item;
      }
    },

    //DOWNLOAD
    // se klice ob pritisku gumba izvoz klasifikacijskega načrta
    //gets called when we click the classification plan export button
    exportClassificationPlan() {
      // odstranimo razrede, ki niso označeni
      // the function removes the classes that are not selected
      let currentClassificationPlan = this.checkClassificationPlanForExport();

      if (currentClassificationPlan.length === 0) {
        this.$bvModal.hide("modal-export");

        this.$swal(
            this.$t('text.globals.error'),
            this.$t(
                "text.classificationPlan.printExportEmptyClassificationPlanErrorSwal.content"
            ),
            "error",
            {dangerMode: true}
        );

        this.$store.dispatch("setFilters", {
          label: "none",
          labelName: "none",
          povezaniSistemi: "none",
          rokHrambe: "none",
          vrstaGradiva: "none",
          vpisnik: "none",
          creationDate: "none",
          usageEndDate: "none"
        });
        this.$store.dispatch("setClassificationPlanFiltered", []);
        this.$store.dispatch("setClassificationPlanFilteredAndChecked", []);
        this.updateFilterKeys();

        return;
      }

      // ker se array kot root element ne bo pravilno sparsal v xml, moramo okoli njega dodati root objekt
      // we need to put a root object around our classification plan, so the parser returns the correct xml
      let classificationPlanPlusRoot = {
        root: {
          item: currentClassificationPlan
        }
      };

      // options za pretvarjanje js2xml
      // parser options object
      const options = {compact: true, spaces: 4};

      // pretvorimo objekt v xml
      // converting the object to xml
      let classificationPlanXML = convert.js2xml(
          classificationPlanPlusRoot,
          options
      );

      // prenos klasifikacijskega načrta v obliki xml
      // calling the download fucnction
      this.downloadClassificationPlan(
          classificationPlanXML,
          "Klasifikacijski Načrt"
      );

      this.$store.dispatch("setFilters", {
        label: "none",
        labelName: "none",
        povezaniSistemi: "none",
        rokHrambe: "none",
        vrstaGradiva: "none",
        vpisnik: "none",
        creationDate: "none",
        usageEndDate: "none"
      });
      this.$store.dispatch("setClassificationPlanFiltered", []);
      this.$store.dispatch("setClassificationPlanFilteredAndChecked", []);
      this.updateFilterKeys();
    },

    // exports a sample xml classification plan
    exportSampleClassificationPlan() {
      const sampleClassificationPlan =
          "<root>\n" +
          "    <item>\n" +
          "        <alfrescoId/>\n" +
          "        <classificationLabel>10201</classificationLabel>\n" +
          "        <classificationLabelName>Novinarska vprašanja</classificationLabelName>\n" +
          "        <classificationLabelDescription>sda</classificationLabelDescription>\n" +
          "        <rokHrambe>\n" +
          "            <expiration>A</expiration>\n" +
          "            <year/>\n" +
          "            <expirationType/>\n" +
          "            <isGeneral>true</isGeneral>\n" +
          "            <alfrescoId/>\n" +
          "        </rokHrambe>\n" +
          "        <rokHrambe>\n" +
          "            <expiration>T</expiration>\n" +
          "            <year/>\n" +
          "            <expirationType>5</expirationType>\n" +
          "            <isGeneral>false</isGeneral>\n" +
          "        </rokHrambe>\n" +
          "        <rokHrambe>\n" +
          "            <expiration>OMEJENO</expiration>\n" +
          "            <expirationType>10</expirationType>\n" +
          "            <isGeneral>false</isGeneral>\n" +
          "            <year>14</year>\n" +
          "        </rokHrambe>\n" +
          "        <vpisnik>741</vpisnik>\n" +
          "        <povezaniSistemi>SUVP</povezaniSistemi>\n" +
          "        <usageEndDate/>\n" +
          "        <creationDate>20-09-2019</creationDate>\n" +
          "        <parentClass>none</parentClass>\n" +
          "        <item>\n" +
          "            <alfrescoId/>\n" +
          "            <classificationLabel>102010</classificationLabel>\n" +
          "            <classificationLabelName>Obvestila za javnost</classificationLabelName>\n" +
          "            <classificationLabelDescription>sd</classificationLabelDescription>\n" +
          "            <rokHrambe>\n" +
          "                <expiration>OMEJENO</expiration>\n" +
          "                <year>3</year>\n" +
          "                <expirationType/>\n" +
          "                <isGeneral>true</isGeneral>\n" +
          "                <alfrescoId/>\n" +
          "            </rokHrambe>\n" +
          "            <vpisnik>748</vpisnik>\n" +
          "            <vpisnik>749</vpisnik>\n" +
          "            <povezaniSistemi>SUVP</povezaniSistemi>\n" +
          "            <usageEndDate>04-08-2019</usageEndDate>\n" +
          "            <creationDate>20-09-2019</creationDate>\n" +
          "            <parentClass>10201</parentClass>\n" +
          "        </item>\n" +
          "        <item>\n" +
          "            <alfrescoId/>\n" +
          "            <classificationLabel>102011</classificationLabel>\n" +
          "            <classificationLabelName>Intervjuji</classificationLabelName>\n" +
          "            <classificationLabelDescription>sa</classificationLabelDescription>\n" +
          "            <rokHrambe>\n" +
          "                <expiration>A</expiration>\n" +
          "                <year/>\n" +
          "                <expirationType/>\n" +
          "                <isGeneral>true</isGeneral>\n" +
          "                <alfrescoId/>\n" +
          "            </rokHrambe>\n" +
          "            <vpisnik>755</vpisnik>\n" +
          "            <povezaniSistemi>SUVP</povezaniSistemi>\n" +
          "            <usageEndDate>18-08-2019</usageEndDate>\n" +
          "            <creationDate>20-09-2019</creationDate>\n" +
          "            <parentClass>10201</parentClass>\n" +
          "            <item>\n" +
          "                <alfrescoId/>\n" +
          "                <classificationLabel>1020111</classificationLabel>\n" +
          "                <classificationLabelName>Mediji - snemanje sodne stavbe</classificationLabelName>\n" +
          "                <classificationLabelDescription>z</classificationLabelDescription>\n" +
          "                <rokHrambe>\n" +
          "                    <expiration>T</expiration>\n" +
          "                    <year/>\n" +
          "                    <expirationType/>\n" +
          "                    <isGeneral>true</isGeneral>\n" +
          "                    <alfrescoId/>\n" +
          "                </rokHrambe>\n" +
          "                <rokHrambe>\n" +
          "                    <expiration>T</expiration>\n" +
          "                    <year/>\n" +
          "                    <expirationType>22</expirationType>\n" +
          "                    <isGeneral>false</isGeneral>\n" +
          "                </rokHrambe>\n" +
          "                <vpisnik>757</vpisnik>\n" +
          "                <povezaniSistemi>SUVP</povezaniSistemi>\n" +
          "                <usageEndDate>05-08-2019</usageEndDate>\n" +
          "                <creationDate>20-09-2019</creationDate>\n" +
          "                <parentClass>102011</parentClass>\n" +
          "            </item>\n" +
          "        </item>\n" +
          "    </item>\n" +
          "    <item>\n" +
          "        <alfrescoId/>\n" +
          "        <classificationLabel>10202</classificationLabel>\n" +
          "        <classificationLabelName>Tiskovne konference</classificationLabelName>\n" +
          "        <classificationLabelDescription>gds</classificationLabelDescription>\n" +
          "        <rokHrambe>\n" +
          "            <expiration>T</expiration>\n" +
          "            <year/>\n" +
          "            <expirationType/>\n" +
          "            <isGeneral>true</isGeneral>\n" +
          "            <alfrescoId/>\n" +
          "        </rokHrambe>\n" +
          "        <rokHrambe>\n" +
          "            <expiration>A</expiration>\n" +
          "            <year/>\n" +
          "            <expirationType>27</expirationType>\n" +
          "            <isGeneral>false</isGeneral>\n" +
          "        </rokHrambe>\n" +
          "        <vpisnik>745</vpisnik>\n" +
          "        <vpisnik>746</vpisnik>\n" +
          "        <povezaniSistemi>SUVP</povezaniSistemi>\n" +
          "        <usageEndDate>05-08-2019</usageEndDate>\n" +
          "        <creationDate>20-09-2019</creationDate>\n" +
          "        <parentClass>none</parentClass>\n" +
          "        <item>\n" +
          "            <alfrescoId/>\n" +
          "            <classificationLabel>102020</classificationLabel>\n" +
          "            <classificationLabelName>Spremljanje medijev</classificationLabelName>\n" +
          "            <classificationLabelDescription>asdg</classificationLabelDescription>\n" +
          "            <rokHrambe>\n" +
          "                <expiration>A</expiration>\n" +
          "                <year/>\n" +
          "                <expirationType/>\n" +
          "                <isGeneral>true</isGeneral>\n" +
          "                <alfrescoId/>\n" +
          "            </rokHrambe>\n" +
          "            <vpisnik>744</vpisnik>\n" +
          "            <povezaniSistemi>SUVP</povezaniSistemi>\n" +
          "            <usageEndDate>13-08-2019</usageEndDate>\n" +
          "            <creationDate>20-09-2019</creationDate>\n" +
          "            <parentClass>10202</parentClass>\n" +
          "        </item>\n" +
          "        <item>\n" +
          "            <alfrescoId/>\n" +
          "            <classificationLabel>102021</classificationLabel>\n" +
          "            <classificationLabelName>Splošna javnost</classificationLabelName>\n" +
          "            <classificationLabelDescription>as</classificationLabelDescription>\n" +
          "            <rokHrambe>\n" +
          "                <expiration>A</expiration>\n" +
          "                <year/>\n" +
          "                <expirationType/>\n" +
          "                <isGeneral>true</isGeneral>\n" +
          "                <alfrescoId/>\n" +
          "            </rokHrambe>\n" +
          "            <vpisnik>741</vpisnik>\n" +
          "            <vpisnik>742</vpisnik>\n" +
          "            <povezaniSistemi>SUVP</povezaniSistemi>\n" +
          "            <usageEndDate>18-08-2019</usageEndDate>\n" +
          "            <creationDate>20-09-2019</creationDate>\n" +
          "            <parentClass>10202</parentClass>\n" +
          "        </item>\n" +
          "    </item>\n" +
          "</root>";

      this.downloadClassificationPlan(
          sampleClassificationPlan,
          "Vzorčni Klasifikacijski Načrt"
      );
    },

    // razrede, ki nimajo checked atributa nastavljenega na true, odstranimo iz klasifikacijskega načrta
    // we remove the deselected classes (the classes with the checked attribute in structure as false)
    checkClassificationPlanForExport() {
      // we create a deep clone of the plan, because we will need to remove the deselected classes
      let classificationPlanToExport = _.cloneDeep(
          this.$store.getters.getClassificationPlanFiltered
      );

      console.log(classificationPlanToExport);

      // we remove the classes which have been deselected
      for (let i = classificationPlanToExport.length - 1; i >= 0; i--) {
        if (classificationPlanToExport[i].structure.checked !== true) {
          classificationPlanToExport.splice(i, 1);
        } else {
          classificationPlanToExport[
              i
              ] = this.checkClassificationPlanForExportRec(
              classificationPlanToExport[i]
          );
        }
      }
      return classificationPlanToExport;
    },
    checkClassificationPlanForExportRec(classificationPlanToExport) {
      for (let i = classificationPlanToExport.item.length - 1; i >= 0; i--) {
        if (classificationPlanToExport.item[i].structure.checked !== true) {
          classificationPlanToExport.item.splice(i, 1);
        } else {
          classificationPlanToExport.item[
              i
              ] = this.checkClassificationPlanForExportRec(
              classificationPlanToExport.item[i]
          );
        }
      }

      // we remove the structure and errors object, because we don't want to show it in the xml
      delete classificationPlanToExport["structure"];
      delete classificationPlanToExport["errors"];
      return classificationPlanToExport;
    },

    // ustvari blob, mu pripne klasifikacijski nacrt v obliki xml in ga prenese
    // we create a blob, attatch the xml document to it and download it
    downloadClassificationPlan(data, fileName) {
      const blob = new Blob([data], {
        type: "text/xml; charset=UTF-8",
        encoding: "UTF-8"
      });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.setAttribute("download", fileName + ".xml");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      //??
      this.$store.dispatch("setClassificationPlan", this.classificationPlan);
      this.$store.dispatch(
          "setClassificationPlanFiltered",
          this.classificationPlan
      );
      this.classificationPlanExport = _.cloneDeep(this.classificationPlan);
      this.filterKey++;
    },

    //UPLOAD
    // ko kliknemo gumb uvoz klasifikacijskega načrta ali naknadni uvoz klasifikacijskega načrta
    // gets called when we click the add classification plan or add additional classification plan button.
    importClassificationPlan() {
      let file = this.$refs.files.files[0];

      //preberemo uvoženo datoteko
      // we read the imported file
      if (file) {
        let r = new FileReader();
        r.onload = function (e) {
          //we succesfully loaded the file

          // the xml
          let classificationPlanXML = e.target.result;

          // opcije xml2js pretvornika
          // xml2js parser options
          let options = {
            compact: true
          };

          // izpraznimo  array za preview klasifikacijskega načrta in array z potencialnimi napakami pri uvozu klas. načrta
          // we clear the preview classification plan array( for the classification plan before we decide to keep it in the store) and the potential upload errors array
          this.uploadErrors = [];
          this.classificationPlanPreview = [];
          this.errorMessages = [];

          //preverimo če je format pravi (XML)
          // checking the format of the imported file
          if (this.checkIfValidType(file)) {
            let classificationPlanJs = null;

            console.log("HERE 1");

            // preverimo, če so podatki v xmlu ustrezno formatirani (če je pri pretvarjanju xml -> js vse ok)
            try {
              classificationPlanJs = convert.xml2js(
                  classificationPlanXML,
                  options
              );
            } catch (err) {
              this.uploadErrors.push(
                  this.$t("text.classificationPlan.XMLStructureError")
              );
              this.$bvModal.show("modal-error");
              return;
            }

            console.log("classificationPlanJs ", classificationPlanJs);

            // if we get to here, the xml2js conversion was successful

            //klasifikacijski načrt ustrezno formatiramo in dodamo datume kreiranja in polja za filtriranje pri izvozu klas. načrta

            if (classificationPlanJs.root && classificationPlanJs.root.item) {
              let classificationPlanFormatted = this.formatObject(
                  classificationPlanJs,
                  "fromXml"
              );

              console.log("classificationPlanFormatted", classificationPlanFormatted);

              if (this.checkForMissingClassificationLabels(classificationPlanFormatted)) {
                // preverimo če gre za uvoz klasifikacijskega načrta ali naknadni uvoz klasifikacijskega načrta
                // we check if we are importing a new classification plan or we  are appending to an existing one

                // this is where the paths for adding a new and appending to an existing classification plan split

                if (!this.isClassificationPlanEmpty) {
                  // če gre za naknadni uvoz klasifikacijskega načrta

                  // we get here if we are appending to an existing classification plan

                  // osnova za preview klasifikacijski načrt je že obstoječi klas. načrt, želimu mu pripeti naknadno uvoženega (ki mu odstranimo root element)
                  // in this case the basis of the preview classification plan is the existing one ( we append the new one to the existing )
                  this.classificationPlanToAppend = classificationPlanFormatted;

                  this.classificationPlanPreview = _.cloneDeep(
                      this.classificationPlan
                  );

                  console.log("HERE 2");
                  console.log("this.classificationPlanPreview", this.classificationPlanPreview);
                  console.log("classificationPlanToAppend", this.classificationPlanToAppend);

                  //v modalnem oknu uporabnika vprašamo , kam želi pripeti naknadno uvožen klasifikacijski načrt, za tem kličemo funkcijo appendToTree, ki v preview drevo postavi naknadno uvožen klasifikacijski načrt, nadaljujemo v funkciji checkFields()
                  // we open a modal where we ask the user where does he want to append the imported classification plan, after that we append the new classification plan to the existing one, then we continue to the checkFields() function
                  this.$bvModal.show("modal-append");
                } else {
                  // če gre za uvoz klasifikacijskega načrta

                  // we get here if we are imporing a new classification plan

                  // ustvarimo preview klasifikacijskega načrta (odstranimo root)
                  // we create the preview of the classification plan (which is in this case just the imported structure without the root object)
                  this.classificationPlanPreview = classificationPlanFormatted;

                  //nadaljujemo v funkciji checkFields
                  // the import process continues in the checkFields function
                  console.log("HERE 3");
                  this.checkFields();
                }
              } else {
                this.uploadErrors.push(
                    this.$t(
                        "text.classificationPlan.missingClassificationLabelsInXML"
                    )
                );
                this.$bvModal.show("modal-error");
              }
            } else {
              this.uploadErrors.push(
                  this.$t("text.classificationPlan.documentStructureError")
              );
              this.$bvModal.show("modal-error");
            }
          } else {
            // napačen tip datoteke
            // the wrong file format was loaded
            this.uploadErrors.push(
                this.$t("text.classificationPlan.fileTypeError")
            );
            this.$bvModal.show("modal-error");
          }
        }.bind(this);

        r.readAsText(file);
      }
    },

    // preverimo če gre za datoteko tipa xml
    // this function checks if the uploaded file was an xml
    checkIfValidType(file) {
      return file.type === "application/xml" || file.type === "text/xml";
    },

    // formatira pretvorjen Klasifikacijski načrt v ustrezno strukturo, ki nam bo olajšala delo z njo
    // we adjust the classification plan structure, so it is easier to work with later
    formatObject(classificationPlanJs, typeOfImport) {
      let classificationPlanFormatted = [];

      // če je root element objekt, ga spremenimo v array
      // if the root class (root.item) is an object, we convert it to an array

      if (!classificationPlanJs.root.item) {
        return classificationPlanFormatted;
      }

      if (classificationPlanJs.root.item.length == null) {
        let itemRootArray = [];
        itemRootArray.push(classificationPlanJs.root.item);
        classificationPlanJs.root.item = itemRootArray;
      }

      if (classificationPlanJs.root.item.length > 0) {
        classificationPlanJs.root.item = _.sortBy(
            classificationPlanJs.root.item,
            [
              function (o) {
                return o.classificationLabel._text;
              }
            ]
        );
      }

      for (let i = 0; i < classificationPlanJs.root.item.length; i++) {
        let obj = this.formatObjectRec(
            classificationPlanJs.root.item[i],
            1,
            "none",
            typeOfImport
        );

        _.map(obj, function (v, k) {
          if (k == "item") {
            obj[k] = _.sortBy(v, [
              function (o) {
                return o.classificationLabel;
              }
            ]);
          }
        });
        classificationPlanFormatted.push(obj);
      }

      return classificationPlanFormatted;
    },

    formatObjectRec(
        classificationPlanJsItem,
        depth,
        parentClassLabel,
        typeOfImport
    ) {
      let formattedClass = {
        alfrescoId: null,
        classificationLabel: null,
        containsRecords: false,
        classificationLabelName: null,
        classificationLabelDescription: null,
        duplicatedClassLabels: [],
        rokHrambe: [],
        vpisnik: [],
        povezaniSistemi: [],
        usageEndDate: null,
        usageStartDate: null,
        creationDate: null,
        parentClass: null,
        item: [],
        errors: {
          classificationLabelNameDuplicateError: false,
          classificationLabel: {
            missing: null,
            valueError: null
          },
          classificationLabelName: null,
          classificationLabelDescription: null,
          rokHrambe: {
            expirationErrors: null,

            generalExpirationError: null,
            expirationFields: []
          },
          povezaniSistemi: null,
          vpisnik: null
        },
        structure: {
          isOpen: null,
          checked: null,
          depth: null,
          changed: false,
          match: false
        }
      };

      if (typeOfImport === "fromServer") {
        formattedClass.structure.changed = false;
      } else if (typeOfImport === "fromXml") {
        formattedClass.structure.changed = true;
      }

      if (
          classificationPlanJsItem.classificationLabel &&
          classificationPlanJsItem.classificationLabel._text
      ) {
        formattedClass.classificationLabel =
            classificationPlanJsItem.classificationLabel._text;
      }

      if (
          classificationPlanJsItem.classificationLabelName &&
          classificationPlanJsItem.classificationLabelName._text
      ) {
        formattedClass.classificationLabelName =
            classificationPlanJsItem.classificationLabelName._text;
      }

      if (
          classificationPlanJsItem.classificationLabelDescription &&
          classificationPlanJsItem.classificationLabelDescription._text
      ) {
        formattedClass.classificationLabelDescription =
            classificationPlanJsItem.classificationLabelDescription._text;
      }

      if (
          classificationPlanJsItem.alfrescoId &&
          classificationPlanJsItem.alfrescoId._text
      ) {
        formattedClass.alfrescoId = classificationPlanJsItem.alfrescoId._text;
      }

      if (
          classificationPlanJsItem.containsRecords &&
          classificationPlanJsItem.containsRecords._text
      ) {
        formattedClass.containsRecords =
            classificationPlanJsItem.containsRecords._text === "true";
      }

      // for expiration we need to also go through all of the fields in a expiration entry
      if (classificationPlanJsItem.rokHrambe) {
        if (classificationPlanJsItem.rokHrambe.length == null) {
          let rokHrambeArray = [];
          rokHrambeArray.push(classificationPlanJsItem.rokHrambe);

          classificationPlanJsItem.rokHrambe = rokHrambeArray;
        }

        let rokHrambeDuplicatesCheckArray = [];

        for (let i = 0; i < classificationPlanJsItem.rokHrambe.length; i++) {
          let expirationEntry = {
            expiration: null,
            year: null,
            expirationType: null,
            isGeneral: false,
            alfrescoId: null
          };

          if (
              classificationPlanJsItem.rokHrambe[i].alfrescoId &&
              classificationPlanJsItem.rokHrambe[i].alfrescoId._text
          ) {
            expirationEntry.alfrescoId =
                classificationPlanJsItem.rokHrambe[i].alfrescoId._text;
          }

          if (
              classificationPlanJsItem.rokHrambe[i].expiration &&
              classificationPlanJsItem.rokHrambe[i].expiration._text
          ) {
            let expirationOptions = this.rokHrambe;

            let expirationErrors = true;

            for (let j = 0; j < expirationOptions.length; j++) {
              if (
                  classificationPlanJsItem.rokHrambe[
                      i
                      ].expiration._text.toString() ===
                  expirationOptions[j].type.toString()
              ) {
                expirationErrors = false;
                break;
              }
            }

            if (!expirationErrors) {
              expirationEntry.expiration =
                  classificationPlanJsItem.rokHrambe[i].expiration._text;
            }
          }

          if (
              classificationPlanJsItem.rokHrambe[i].expirationType &&
              classificationPlanJsItem.rokHrambe[i].expirationType._text
          ) {
            // let expirationTypeOptions = ['ZUP povratnica PUND','ZUP povratnica Su','ZPP povatnica PUND',
            //     'ZPP povratnica iI', 'Tožba', 'Vloga', 'Pritožba', 'Sodba'];
            //let expirationTypeOptions = this.$store.getters.getStorageDateOptions;

            let expirationTypeOptions = this.vrstaGradiva;

            let expirationTypeErrors = true;

            for (let j = 0; j < expirationTypeOptions.length; j++) {
              if (
                  classificationPlanJsItem.rokHrambe[i].expirationType._text ==
                  expirationTypeOptions[j].id.toString()
              ) {
                expirationTypeErrors = false;
                break;
              }
            }

            if (!expirationTypeErrors) {
              expirationEntry.expirationType =
                  classificationPlanJsItem.rokHrambe[i].expirationType._text;
            }
          }

          if (
              classificationPlanJsItem.rokHrambe[i].isGeneral &&
              classificationPlanJsItem.rokHrambe[i].isGeneral._text
          ) {
            if (
                classificationPlanJsItem.rokHrambe[i].isGeneral._text === "true"
            ) {
              expirationEntry.isGeneral = true;
            } else if (
                classificationPlanJsItem.rokHrambe[i].isGeneral._text === "false"
            ) {
              expirationEntry.isGeneral = false;
            } else {
              expirationEntry.isGeneral = false;
            }
          }

          if (
              classificationPlanJsItem.rokHrambe[i].year &&
              classificationPlanJsItem.rokHrambe[i].year._text
          ) {
            expirationEntry.year =
                classificationPlanJsItem.rokHrambe[i].year._text;
          }

          if (
              !_.isEmpty(classificationPlanJsItem.rokHrambe[i]) &&
              !rokHrambeDuplicatesCheckArray.includes(
                  expirationEntry.expirationType
              )
          ) {
            rokHrambeDuplicatesCheckArray.push(expirationEntry.expirationType);
            formattedClass.rokHrambe.push(expirationEntry);
          }
        }
      }

      if (classificationPlanJsItem.povezaniSistemi) {
        if (classificationPlanJsItem.povezaniSistemi.length == null) {
          let povezaniSistemiArray = [];
          povezaniSistemiArray.push(classificationPlanJsItem.povezaniSistemi);

          classificationPlanJsItem.povezaniSistemi = povezaniSistemiArray;
        }

        let povezaniSistemiDuplicatesCheckArray = [];

        for (
            let i = 0;
            i < classificationPlanJsItem.povezaniSistemi.length;
            i++
        ) {
          let povezaniSistemiOptions = this.povezaniSistemi;

          let povezaniSistemiErrors = true;

          if (
              classificationPlanJsItem.povezaniSistemi[i]._text &&
              !povezaniSistemiDuplicatesCheckArray.includes(
                  classificationPlanJsItem.povezaniSistemi[i]._text
              )
          ) {
            povezaniSistemiDuplicatesCheckArray.push(
                classificationPlanJsItem.povezaniSistemi[i]._text
            );

            for (let j = 0; j < povezaniSistemiOptions.length; j++) {
              if (
                  classificationPlanJsItem.povezaniSistemi[i]._text ===
                  povezaniSistemiOptions[j].id.toString()
              ) {
                povezaniSistemiErrors = false;
                break;
              }
            }

            if (!povezaniSistemiErrors) {
              formattedClass.povezaniSistemi.push(
                  classificationPlanJsItem.povezaniSistemi[i]._text
              );
            }
          }
        }
      }

      if (classificationPlanJsItem.vpisnik) {
        if (classificationPlanJsItem.vpisnik.length == null) {
          let vpisnikArray = [];
          vpisnikArray.push(classificationPlanJsItem.vpisnik);

          classificationPlanJsItem.vpisnik = vpisnikArray;
        }

        let vpisnikDuplicatesCheckArray = [];

        for (let i = 0; i < classificationPlanJsItem.vpisnik.length; i++) {
          this.getVpisnikiOptions(formattedClass);
          let vpisnikOptions = this.filteredVpisniki;

          let vpisnikErrors = true;

          if (
              classificationPlanJsItem.vpisnik[i]._text &&
              !vpisnikDuplicatesCheckArray.includes(
                  classificationPlanJsItem.vpisnik[i]._text
              )
          ) {
            vpisnikDuplicatesCheckArray.push(
                classificationPlanJsItem.vpisnik[i]._text
            );

            for (let j = 0; j < vpisnikOptions.length; j++) {
              if (
                  classificationPlanJsItem.vpisnik[i]._text ===
                  vpisnikOptions[j].id.toString() &&
                  _.includes(
                      formattedClass.povezaniSistemi,
                      vpisnikOptions[j].connectedSystem
                  )
              ) {
                vpisnikErrors = false;
                break;
              }
            }
            if (!vpisnikErrors) {
              formattedClass.vpisnik.push(
                  classificationPlanJsItem.vpisnik[i]._text
              );
            }
          }
        }
      }

      // we check if the imported dates are valid (if not, we remove them)

      if (
          classificationPlanJsItem.usageEndDate &&
          classificationPlanJsItem.usageEndDate._text
      ) {
        let usageEndDateMoment = this.moment(
            classificationPlanJsItem.usageEndDate._text,
            "DD-MM-YYYY"
        );

        if (usageEndDateMoment.isValid()) {
          formattedClass.usageEndDate =
              classificationPlanJsItem.usageEndDate._text;
        }
      }

      if (
          classificationPlanJsItem.usageStartDate &&
          classificationPlanJsItem.usageStartDate._text
      ) {
        let usageStartDateMoment = this.moment(
            classificationPlanJsItem.usageStartDate._text,
            "DD-MM-YYYY"
        );

        if (usageStartDateMoment.isValid()) {
          formattedClass.usageStartDate =
              classificationPlanJsItem.usageStartDate._text;
        }
      }

      // i think that we should ignore/throw out the parentClass tag, because it is easily set when importing the plan
      /*
                if(classificationPlanJsItem.parentClass && classificationPlanJsItem.parentClass._text) {
                    formattedClass.parentClass = classificationPlanJsItem.parentClass._text;
                }
                */

      // we set the parent class because it is useful to have it for moving, adding new classes ...
      formattedClass.parentClass = parentClassLabel;

      //the  first two levels of the classification plan should be opened when we import the plan

      formattedClass.structure.isOpen = depth === 1 || depth === 2;
      formattedClass.structure.depth = depth;
      formattedClass.structure.checked = true;

      if (typeOfImport === "fromServer") {
        if (
            classificationPlanJsItem.creationDate &&
            classificationPlanJsItem.creationDate._text
        ) {
          formattedClass.creationDate =
              classificationPlanJsItem.creationDate._text;
        }
      } else {
        // creation date attribute is added
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = today.getFullYear();
        today = dd + "-" + mm + "-" + yyyy;

        formattedClass.creationDate = today;
      }

      // if there is no children we put an empty array

      if (!classificationPlanJsItem.item) {
        classificationPlanJsItem.item = [];
      }

      // if there is only one child, the parser interprets it as an object, so we need to convert it to an array
      else if (classificationPlanJsItem.item.length == null) {
        let itemArray = [];
        itemArray.push(classificationPlanJsItem.item);
        classificationPlanJsItem.item = itemArray;
      }

      //finally, we recursively call the function on all the children

      for (let i = 0; i < classificationPlanJsItem.item.length; i++) {
        formattedClass.item.push(
            this.formatObjectRec(
                classificationPlanJsItem.item[i],
                depth + 1,
                formattedClass.classificationLabel,
                typeOfImport
            )
        );
      }

      formattedClass.item = _.sortBy(
          formattedClass.item,
          [
            function (o) {
              return o.classificationLabel;
            }
          ]
      );

      return formattedClass;
    },

    // (se izvede samo pri naknadnem uvozu klasifikacijskega načrta), pripne naknadno uvožen klas. načrt k že obstoječemu

    // gets called if we are appending an additional classification plan, after we've selected the class that we want to append to in the modal
    appendToTree() {
      // parentLabel is the label of the class that we are appending to at the moment
      let parentLabel = this.selectedClassLabel;

      // first we push all classification labels of our classification plan preview to an array
      this.setLabelArr();

      // we iterate through all the classes of the tree that we want to append
      for (let i = 0; i < this.classificationPlanToAppend.length; i++) {
        this.classificationPlanToAppend[i].parentClass = parentLabel;

        this.appendToTreeRec(this.classificationPlanToAppend[i], parentLabel);
      }

      // because we added classes to an existing classification plan, we need to update the depth and isOpen variables
      this.classificationPlanPreview = this.checkDepth(
          this.classificationPlanPreview
      );

      // this is the function where we continue our import progress
      this.checkFields();
    },

    appendToTreeRec(classificationPlanToAppend, parentLabel) {
      //we need to handle adding to root
      if (parentLabel === "none") {
        if (!this.classificationPlanLabels.includes(classificationPlanToAppend.classificationLabel)) {
          let classToAppend = _.cloneDeep(classificationPlanToAppend);

          classToAppend.item = [];

          this.classificationPlanPreview.push(classToAppend);
        } else {
          // detect if class with same classificationLabel already exists in ClassificationPlan

          this.errorMessages.push({
            id: classificationPlanToAppend.classificationLabel,
            message: this.$t("text.classificationPlan.importErrorDuplicatedClassLabelPart1") + ' ' + classificationPlanToAppend.classificationLabel + ' ' + this.$t("text.classificationPlan.importErrorDuplicatedClassLabelPart2") + ' ' + classificationPlanToAppend.classificationLabelName + ' ' + this.$t("text.classificationPlan.importErrorDuplicatedClassLabelPart3")
          });

        }
      }
      // for each class in the toAppend tree, we check if the current class already exists in our classification plan preview
      else if (
          !this.classificationPlanLabels.includes(
              classificationPlanToAppend.classificationLabel
          )
      ) {
        //if the class doesn't already exist in the preview plan, we take just the current class (without its children) and append it to the class with parentlabel label

        let classToAppend = _.cloneDeep(classificationPlanToAppend);

        classToAppend.item = [];

        // we call a function that appends our current class to the class in the preview plan with the classificationLabel === parentLabel
        this.addClassToParent(classToAppend, parentLabel);
      }

      for (let i = 0; i < classificationPlanToAppend.item.length; i++) {
        this.appendToTreeRec(
            classificationPlanToAppend.item[i],
            classificationPlanToAppend.classificationLabel
        );
      }
    },

    // we check if the preview classification plan has any missing classification labels; we return true if everything is ok
    checkForMissingClassificationLabels(classificationPlan) {
      for (let i = 0; i < classificationPlan.length; i++) {
        if (
            !this.checkForMissingClassificationLabelsRec(classificationPlan[i])
        ) {
          return false;
        }
      }

      return true;
    },
    checkForMissingClassificationLabelsRec(classificationPlan) {
      if (classificationPlan.classificationLabel == null) {
        return false;
      }

      for (let i = 0; i < classificationPlan.item.length; i++) {
        if (
            !this.checkForMissingClassificationLabelsRec(
                classificationPlan.item[i]
            )
        ) {
          return false;
        }
      }

      return true;
    },

    // this function pushes all the classification plan labels  into an array
    setLabelArr() {
      let classificationPlan = this.classificationPlanPreview;

      for (let i = 0; i < classificationPlan.length; i++) {
        this.setLabelArrRec(classificationPlan[i]);
      }
    },
    setLabelArrRec(classificationPlan) {
      this.classificationPlanLabels.push(
          classificationPlan.classificationLabel
      );

      for (let i = 0; i < classificationPlan.item.length; i++) {
        this.setLabelArrRec(classificationPlan.item[i]);
      }
    },

    // this function iterates through all of the classes in our classification plan preview and appends the class we pass in where the parentlabel matches the classificationLabel

    addClassToParent(classToAppend, parentLabel) {
      for (let i = 0; i < this.classificationPlanPreview.length; i++) {
        this.classificationPlanPreview[i] = this.addClassToParentRec(
            this.classificationPlanPreview[i],
            classToAppend,
            parentLabel
        );
      }
    },
    addClassToParentRec(classificationPlan, classToAppend, parentLabel) {
      if (classificationPlan.classificationLabel === parentLabel) {
        classificationPlan.item.push(classToAppend);
      } else {
        for (let i = 0; i < classificationPlan.item.length; i++) {
          classificationPlan.item[i] = this.addClassToParentRec(
              classificationPlan.item[i],
              classToAppend,
              parentLabel
          );
        }
      }
      return classificationPlan;
    },

    //popravimo polje depth pri appendanju classificationPlana, saj imamo drugace na appendanem planu napacne depth vrednosti
    // this function updates the depth and isOpen variables in a classificationPlan
    checkDepth(classificationPlan) {
      for (let i = 0; i < classificationPlan.length; i++) {
        classificationPlan[i] = this.checkDepthRec(classificationPlan[i], 1);
      }

      return classificationPlan;
    },
    checkDepthRec(classificationPlan, depth) {
      classificationPlan.structure["depth"] = depth;
      if (depth < 3) {
        classificationPlan.structure["isOpen"] = true;
      } else {
        classificationPlan.structure["isOpen"] = false;
      }
      for (let i = 0; i < classificationPlan.item.length; i++) {
        classificationPlan.item[i] = this.checkDepthRec(
            classificationPlan.item[i],
            depth + 1
        );
      }

      return classificationPlan;
    },

    // nadaljevanje uvoza klasifikacijskega načrta
    // this is where the paths for adding a new and appending to an existing classification plan come together
    checkFields() {
      // console.log("-----> this.classificationPlanPreview", this.classificationPlanPreview);

      if (!this.checkForDuplicateClasses()) {
        // checkValidity function validates all fields in the classification plan and saves information about field errors in the errors structure inside each class
        this.checkFieldValidity(this.classificationPlanPreview);
        //console.log("this.checkFieldValidity(this.classificationPlanPreview);", this.checkFieldValidity(this.classificationPlanPreview));
      } else {
        this.uploadErrors.push(
            this.$t("text.classificationPlan.duplicateClassesError") + ' ' + this.$t("text.classificationPlan.duplicatedClasses") + ' ' + this.duplicatedClassLabels + '.'
        );
        console.log("duplicatedClassLabels", this.duplicatedClassLabels);
      }
      // if there is no errors, the success modal is shown, where the user can either confirm or decline the import( if the user confirms, the dispatchPreviewedClassificationPlan() is called; if there are errors, the user can see the error types and can just decline the import
      if (this.uploadErrors.length === 0) {
        this.$bvModal.show("modal-success");

        // ce je vse ok in uporabnik potrdi uvoz kličemo funkcijo, ki dispatcha preview klas. načrt
      } else {
        this.$bvModal.show("modal-error");
        //  ce ni vse ok, se izpisejo napake, lahko samo zavrnemo
      }
    },

    // če preview classification plan prestane vse validacije, ga dispatchamo v store, preview classification plan postane classificationPlan
    // if the preview classification plan contains no errors and the user confirms the import, the preview plan is dispatched
    dispatchPreviewedClassificationPlan() {
      this.$store.dispatch(
          "setClassificationPlan",
          this.classificationPlanPreview
      );
      this.$store.dispatch(
          "setClassificationPlanFiltered",
          this.classificationPlanPreview
      );
      this.classificationPlan = this.$store.getters.getClassificationPlan;

      // do we need this??
      this.classificationPlanExport = JSON.parse(
          JSON.stringify(this.classificationPlan)
      );
      this.classificationPlanPrint = JSON.parse(
          JSON.stringify(this.classificationPlan)
      );
      this.updateFilterKeys();
    },

    //preverimo, če kakšen razred v uvoženem klasifikacijskem načrtu že obstaja (iskanje duplikatov v preview klasifikacijskem načrtu)
    checkForDuplicateClasses() {

      this.duplicatedClassLabels = [];
      this.classificationPlanDuplicatesCheckArray = [];

      for (let i = 0; i < this.classificationPlanPreview.length; i++) {
        this.checkForDuplicateClassesRec(this.classificationPlanPreview[i]);
      }

      if (this.duplicatedClassLabels.length === 0) {
        return false;
      } else {
        return true;
      }

    },
    checkForDuplicateClassesRec(classificationPlan) {

      if (
          this.classificationPlanDuplicatesCheckArray.includes(
              classificationPlan.classificationLabel
          )
      ) {
        this.duplicatedClassLabels.push(classificationPlan.classificationLabel);
      } else {
        this.classificationPlanDuplicatesCheckArray.push(
            classificationPlan.classificationLabel
        );

        for (let i = 0; i < classificationPlan.item.length; i++) {
          this.checkForDuplicateClassesRec(classificationPlan.item[i]);
        }
      }

    },

    getVpisnikiOptions(classificationPlan) {
      let filteredVpisniki = [];

      _.forEach(this.vpisniki, function (value, key) {
        if (
            _.includes(classificationPlan.povezaniSistemi, value.connectedSystem)
        ) {
          filteredVpisniki.push(value);
        }
      });

      this.filteredVpisniki = filteredVpisniki;
    },

    // this function iterates through all of the required fields inside a classification plan and checks their validity, the information about field validity is then saved in the errors structure inside each class
    checkFieldValidity(classificationPlan) {
      let areFieldsValid = true;

      if (classificationPlan.length > 0) {
        let childClassificationLabelNames = {};

        for (let i = 0; i < classificationPlan.length; i++) {
          if (
              !childClassificationLabelNames[
                  classificationPlan[i].classificationLabelName
                  ]
          ) {
            childClassificationLabelNames[
                classificationPlan[i].classificationLabelName
                ] = [];
            childClassificationLabelNames[
                classificationPlan[i].classificationLabelName
                ].push(i);
          } else {
            childClassificationLabelNames[
                classificationPlan[i].classificationLabelName
                ].push(i);
          }
        }

        // console.log("childClassificationLabelNames: ", childClassificationLabelNames );

        for (let key of Object.keys(childClassificationLabelNames)) {
          if (childClassificationLabelNames[key].length > 1) {
            for (
                let i = 0;
                i < childClassificationLabelNames[key].length;
                i++
            ) {
              // console.log(
              //     "nastavimo na true, ker se: ",
              //     key,
              //     " pojavi ",
              //     childClassificationLabelNames[key].length,
              //     "-krat --->",
              //     childClassificationLabelNames[key]
              // );

              if (!_.find(this.errorMessages, {id: key})) {
                /*this.errorMessages.push({
                                        id: key,
                                        message: 'Klasifikacijska oznaka ' + key + ' se v klasifikacijskem načrtu pojavlja ' + childClassificationLabelNames[key].length + '-krat.'
                                    });
                                    */
              }

              /*classificationPlan[
                                    childClassificationLabelNames[key][i]
                                    ].errors.classificationLabelNameDuplicateError = true;

                                areFieldsValid = false;
                                */
            }
          } else {
            // console.log("damo na false in sicer ", childClassificationLabelNames[key][0]);
            classificationPlan[
                childClassificationLabelNames[key][0]
                ].errors.classificationLabelNameDuplicateError = false;
          }
        }
      }

      for (let i = 0; i < classificationPlan.length; i++) {
        // console.log("classificationPlan[i]", classificationPlan[i]);
        if (!this.checkFieldValidityRec(classificationPlan[i], false)) {
          areFieldsValid = false;
        }
      }

      return areFieldsValid;
    },

    checkFieldValidityRec(classificationPlan, classificationLabelValueError) {
      let classValueError = classificationLabelValueError;

      let areFieldsValid = true;

      // inside each class we iterate through all the fields, for almost every field there are different rules for validating it
      for (let key of Object.keys(classificationPlan.errors)) {
        if (key === "classificationLabelNameDuplicateError") {
          // check if there are any duplicate classificationLabelNames amongst the children nodes
          if (classificationPlan.item.length > 0) {
            let childClassificationLabelNames = {};

            for (let i = 0; i < classificationPlan.item.length; i++) {
              if (
                  !childClassificationLabelNames[
                      classificationPlan.item[i].classificationLabelName
                      ]
              ) {
                childClassificationLabelNames[
                    classificationPlan.item[i].classificationLabelName
                    ] = [];
                childClassificationLabelNames[
                    classificationPlan.item[i].classificationLabelName
                    ].push(i);
              } else {
                childClassificationLabelNames[
                    classificationPlan.item[i].classificationLabelName
                    ].push(i);
              }
            }

            // console.log("childClassificationLabelNames: ", childClassificationLabelNames );

            for (let key of Object.keys(childClassificationLabelNames)) {
              if (childClassificationLabelNames[key].length > 1) {
                for (
                    let i = 0;
                    i < childClassificationLabelNames[key].length;
                    i++
                ) {
                  /*
                                        classificationPlan.item[
                                            childClassificationLabelNames[key][i]
                                            ].errors.classificationLabelNameDuplicateError = true;
                                        areFieldsValid = false;
                                        */
                  // console.log("nastavimo na true, ker se: ", key , " pojavi ",  childClassificationLabelNames[key].length, "-krat --->", childClassificationLabelNames[key] );
                }
              } else {
                // console.log("damo na false in sicer ", childClassificationLabelNames[key][0]);
                classificationPlan.item[
                    childClassificationLabelNames[key][0]
                    ].errors.classificationLabelNameDuplicateError = false;
              }
            }
          }
        }

        // check if there are any illegal character in classificationLabelNames
        else if (key === "classificationLabelNameIllegalCharactersError") {
          let regex = RegExp("^[a-zA-Z0-9ČĆŠĐŽčćšđž_./():,\\- ]+$");

          if (regex.test(classificationPlan.classificationLabelName)) {
            classificationPlan.errors.classificationLabelNameIllegalCharactersError = false;
          } else {
            classificationPlan.errors.classificationLabelNameIllegalCharactersError = true;
            areFieldsValid = false;
          }
        } else if (
            key === "rokHrambe" ||
            key === "vpisnik" ||
            key === "povezaniSistemi"
        ) {
          // validation for the key 'rokHrambe'
          if (key === "rokHrambe") {
            classificationPlan.errors.rokHrambe.expirationErrors = false;
            classificationPlan.errors.rokHrambe.generalExpirationError = false;

            // if the rokHrambe is an empty array, we just set the expirationErrors (general errors) and generalExpirationError (there should be one general expiration) to true
            if (classificationPlan.rokHrambe.length === 0) {
              classificationPlan.errors.rokHrambe.expirationErrors = true;
              classificationPlan.errors.rokHrambe.generalExpirationError = true;
              areFieldsValid = false;
            } else {
              //else we check all of the expiration entries and also count how many of them are general (there needs to be only one for each class)

              let generalExpirationNumber = 0;

              for (let i = 0; i < classificationPlan.rokHrambe.length; i++) {
                //if the expiration is general, we increase the number of general expirations inside the class
                if (classificationPlan.rokHrambe[i].isGeneral) {
                  generalExpirationNumber++;
                }

                // for expiration we just check if there is one present
                let expiration =
                    classificationPlan.rokHrambe[i].expiration == null ||
                    classificationPlan.rokHrambe[i].expiration === "";
                let year = {
                  missing: false,
                  numericError: false
                };
                let expirationType = false;

                // if expiration is  set to "OMEJENO" we also need to validate the year variable, otherwise not
                if (classificationPlan.rokHrambe[i].expiration === "OMEJNO") {
                  year.numericError =
                      isNaN(classificationPlan.rokHrambe[i].year) ||
                      !classificationPlan.rokHrambe[i].year.match(/^[1-9]\d*$/);
                  year.missing =
                      classificationPlan.rokHrambe[i].year == null ||
                      classificationPlan.rokHrambe[i].year === "";
                } else {
                  year.missing = false;
                  year.numericError = false;
                }

                // if the expiration is general, we dont validate expirationType, otherwise we do
                if (classificationPlan.rokHrambe[i].isGeneral) {
                  expirationType = false;
                } else {
                  expirationType =
                      classificationPlan.rokHrambe[i].expirationType == null ||
                      classificationPlan.rokHrambe[i].expirationType === "";
                }

                // we make an errors object for this expiration entry and push it to the array of error entries for the expirations for the current class
                let rokHrambeEntryErrors = {
                  expiration: expiration,
                  expirationType: expirationType,
                  year: year
                };
                classificationPlan.errors.rokHrambe.expirationFields.push(
                    rokHrambeEntryErrors
                );

                // if there is an error in any of the fields we mark an expiration error
                if (
                    expiration ||
                    year.missing ||
                    year.numericError ||
                    expirationType
                ) {
                  classificationPlan.errors.rokHrambe.expirationErrors = true;
                  areFieldsValid = false;
                }
              }

              // if the number of general expirations in the class is not 1, we mark a general expiration error
              if (generalExpirationNumber !== 1) {
                classificationPlan.errors.rokHrambe.generalExpirationError = true;
                classificationPlan.errors.rokHrambe.expirationErrors = true;

                areFieldsValid = false;
              }
            }
          } else if (key === "vpisnik") {
            // if the field is an array ("vpisnik" or "povezaniSistemi" ) we just check its length (if it's not 0)

            this.getVpisnikiOptions(classificationPlan);

            if (
                (classificationPlan[key].length === 0) ===
                (this.filteredVpisniki.length === 0)
            ) {
              classificationPlan.errors[key] = false;
            } else {
              classificationPlan.errors[key] = true;
              areFieldsValid = false;
            }
          } else {
            if (classificationPlan[key].length === 0) {
              classificationPlan.errors[key] = true;
              areFieldsValid = false;
            } else {
              classificationPlan.errors[key] = false;
            }
          }
        } else {
          // classification label has an error object with an attribute missing to mark an error in
          if (key === "classificationLabel") {
            let regex = RegExp("^[0-9]+$");

            if (
                classificationPlan.classificationLabel == null ||
                classificationPlan.classificationLabel === ""
            ) {
              classificationPlan.errors.classificationLabel.missing = true;
              classificationPlan.errors.classificationLabel.valueError = true;
              areFieldsValid = false;
            } else if (!regex.test(classificationPlan.classificationLabel)) {
              classificationPlan.errors.classificationLabel.valueError = true;
              areFieldsValid = false;
            } else {
              classificationPlan.errors.classificationLabel.missing = false;

              if (classificationPlan.parentClass !== "none") {
                if (
                    !(
                        classificationPlan.classificationLabel.startsWith(
                            classificationPlan.parentClass
                        ) &&
                        classificationPlan.classificationLabel.length >
                        classificationPlan.parentClass.length
                    ) ||
                    classValueError
                ) {
                  classificationPlan.errors.classificationLabel.valueError = true;
                  classValueError = true;
                  areFieldsValid = false;
                } else {
                  classificationPlan.errors.classificationLabel.valueError = false;
                }
              } else {
                classificationPlan.errors.classificationLabel.valueError = false;
              }
            }
          } else {
            // in general we check if the field exists and save the potential error to the error object

            if (
                classificationPlan[key] == null ||
                classificationPlan[key] === ""
            ) {
              classificationPlan.errors[key] = true;
              areFieldsValid = false;
            } else {
              classificationPlan.errors[key] = false;
            }
          }
        }
      }

      // recursive call
      for (let i = 0; i < classificationPlan.item.length; i++) {
        if (
            !this.checkFieldValidityRec(
                classificationPlan.item[i],
                classValueError
            )
        ) {
          areFieldsValid = false;
        }
      }

      return areFieldsValid;
    },

    //DODAJANJE
    //se klice, ko zelimo dodati posamezen vnos v classification plan
    // if we press the button to add a new class to the classification plan, this function is called, it redirects us to /classificationPlan/addClassificationPlanEntry/:classificationLabel (classification label of the parent class)
    addClassificationPlanEntry() {
      this.$router.push(
          "/classificationPlan/addClassificationPlanEntry/" +
          this.selectedClassLabel
      );
    },

    //UREJANJE
    // se kliče ob kliku na gumb urejanje razreda, nas preusmeri na stran za urejanje vnosa v klasifikacijskem načrtu
    // if we press the button to edit a class in the classification plan, this function is called, it redirects us to /classificationPlan/editClassificationPlanEntry/:classificationLabel
    editClassificationPlanEntry() {
      if (this.selectedClassLabel !== "none") {
        if (this.selectedClass.containsRecords) {
          /*this.$swal(
                  this.$t('text.globals.error'),
                  this.$t(
                          "text.classificationPlan.editClassificationPlanEntryContainingRecordsErrorSwal.content"
                  ));
                  */
          let editUrl =
              "/classificationPlan/editClassificationPlanEntry/" +
              this.selectedClassLabel;

          console.log("edit url: ", editUrl);

          this.$router.push(editUrl);
        } else {
          let editUrl =
              "/classificationPlan/editClassificationPlanEntry/" +
              this.selectedClassLabel;

          console.log("edit url: ", editUrl);

          this.$router.push(editUrl);
        }
      } else {
        console.log("izberite razred");
      }
    },

    // if we press the button to review the classification plan, this function is called, it redirects us to /classificationPlanReview
    reviewClassificationPlan() {
      this.$router.push("/classificationPlanReview");
    },

    // if we press the button to print the classification plan, this function is called, it redirects us to /classificationPlanReview
    printClassificationPlan() {
      const _this = this;

      let currentClassificationPlan = this.checkClassificationPlanForExport();

      if (currentClassificationPlan.length === 0) {
        _this.$bvModal.hide("modal-print");

        _this.$swal(
            this.$t('text.globals.error'),
            this.$t(
                "text.classificationPlan.printExportEmptyClassificationPlanErrorSwal.content"
            ),
            "error",
            {dangerMode: true}
        );
        return;
      }

      _this.isLoading = true;

      let knIds = [];
      let temp = flatten(currentClassificationPlan);

      _.map(temp, function (val, key) {
        let nameArr = key.split('.');
        _.map(nameArr, function (_val, _key) {
          if (_val === 'classificationLabel') {
            knIds.push(val);
          }
        });
      });


      let data = {
        knIds: knIds
      };

      let explanations = [];
      let firstExplanation = true;
      _.each(this.$store.getters.getFilters, function (filter, key, idx, i) {

        let keyTranslated = null;
        let _parameter = _.filter(_this.$t('text.classificationPlan.searchableFieldsPrint'), {id: key});
        if (_parameter.length > 0) {
          keyTranslated = _parameter[0].description;
        } else {
          keyTranslated = key;
        }

        //console.log("aaaa ", filter, key, idx,i);
        if (filter && filter !== 'none') {
          if (key !== 'creationDate' && key !== 'usageEndDate') {
            explanations.push({"operator": firstExplanation ? "" : "IN", "parameter": keyTranslated, "value": filter});
            firstExplanation = false;
          } else {
            if (filter.start !== null || filter.end !== null) {
              explanations.push({
                "operator": firstExplanation ? "" : "IN",
                "parameter": keyTranslated,
                "value": ('Od: ' + (filter.start ? filter.start : "-") + ", do: " + (filter.end ? filter.end : "-"))
              });
              firstExplanation = false;
            }
          }
        }


      });

      if (explanations.length === 0) {
        explanations = [{operator: '', parameter: '', value: '-'}];
      }
      data.explanations = explanations;

      axios
          .post(config.reports + "printClassificationPlan", data, {
            responseType: "blob"
          })
          .then(res => {
            const url = window.URL.createObjectURL(
                _this.blobToFile(res.data, "Klasifikacijski_nacrt")
            );
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", "klasifikacijski_nacrt.pdf");
            link.setAttribute("type", "application/pdf");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            _this.isLoading = false;


            _this.$store.dispatch("setFilters", {
              label: "none", labelName: "none", povezaniSistemi: "none", rokHrambe: "none",
              vrstaGradiva: "none", vpisnik: "none", creationDate: "none", usageEndDate: "none"
            });
            _this.$store.dispatch("setClassificationPlanFiltered", []);
            _this.$store.dispatch("setClassificationPlanFilteredAndChecked", []);


          })
          .catch(error => {
            _this.isLoading = false;
            console.error(error);
          });
    },

    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },

    generateReport(reportType) {
      const _this = this;

      let classificationPlan = _this.checkClassificationPlanForExport();

      if (classificationPlan.length === 0) {
        //this.$bvModal.hide("modal-reports");
        this.$swal(
            this.$t('text.globals.error'),
            this.$t(
                "text.classificationPlan.printExportEmptyClassificationPlanErrorSwal.content"
            ),
            "error",
            {dangerMode: true}
        );
        return;
      }

      let knIds = [];
      let temp = flatten(classificationPlan);

      _.map(temp, function (val, key) {
        let nameArr = key.split('.');
        _.map(nameArr, function (_val, _key) {
          if (_val === 'classificationLabel') {
            knIds.push(val);
          }
        });
      });

      if (knIds.length > 100) {
        //this.$bvModal.hide("modal-reports");
        this.$swal(
            this.$t('text.globals.error'),
            this.$t(
                "text.classificationPlan.tooManyClassificationClassesSelected.content"
            ),
            "error",
            {dangerMode: true}
        );
        return;
      }

      _this.$bvModal.hide('modal-reports');
      _this.$refs['filterKey2'].clearAllFilters();

      let data = {
        classificationNumbers: knIds,
        reportType: reportType
      };

      _this.$globalFunctions.generateReport(data);
    },

    exportStorageDates() {
      const _this = this;

      let classificationPlan = _this.checkClassificationPlanForExport();

      if (classificationPlan.length === 0) {
        this.$bvModal.hide("modal-reports");
        this.$swal(
            this.$t('text.globals.error'),
            this.$t(
                "text.classificationPlan.printExportEmptyClassificationPlanErrorSwal.content"
            ),
            "error",
            {dangerMode: true}
        );
        return;
      }

      let knIds = [];
      let temp = flatten(classificationPlan);

      _.map(temp, function (val, key) {
        let nameArr = key.split('.');
        _.map(nameArr, function (_val, _key) {
          if (_val === 'classificationLabel') {
            knIds.push(val);
          }
        });
      });

      let data = {
        knIds: knIds,
        nodeIds: []
      };

      axios.post(config.rootEhramba + 'rokiHrambeExport', data)
          .then((res) => {
            console.log("res", res);
            _this.$globalFunctions.downloadXmlFile(res.data, 'Izvoz_rokov_hrambe');
          })
          .catch((error) => {
            console.log("error", error);
          });


    },

    //BRISANJE
    // se kliče ob kliku na gumb brisanje razreda, izbriše posamezen izbran razred iz klsaifikacijskega načrta
    // if we press the button to delete a classification plan entry, this function is called
    // this function iterates through all the classes and deletes the selected one
    deleteClassificationPlanEntry() {
      let _this = this;

      this.$swal({
        title: this.$t('text.globals.warningTitle'),
        text:
            this.$t(
                "text.classificationPlan.deleteClassificationPlanEntrySwal.content"
            ) +
            this.selectedClassLabel +
            ") " +
            this.selectedClassLabelName +
            "?",
        dangerMode: true,
        buttons: {
          cancel: {
            text: this.$t("text.globals.cancel"),
            value: null,
            visible: true,
            className: "",
            closeModal: true
          },
          confirm: {
            text: this.$t("text.globals.delete"),
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        }
      }).then(value => {
        switch (value) {
          case true:
            _this.deleteClassificationPlanEntryConfiremd();

          case null:
            return;

            break;

          default:
        }
      });
    },

    deleteClassificationPlanEntryConfiremd() {
      const _this = this;

      console.log("selectedClassLabel", this.selectedClassLabel);

      if (this.selectedClassLabel !== "none") {
        for (let i = this.classificationPlan.length - 1; i >= 0; i--) {
          console.log("HERE2");
          console.log("this.classificationPlan[i]", this.classificationPlan[i]);

          if (
              this.classificationPlan[i].classificationLabel ==
              this.selectedClassLabel
          ) {
            console.log("HERE3");
            console.log(this.classificationPlan[i]);

            if (this.classificationPlan[i].containsRecords) {
              this.$swal(
                  this.$t('text.globals.error'),
                  this.$t(
                      "text.classificationPlan.deleteClassificationPlanEntryContainingDocumentsErrorSwal.content"
                  ),
                  "error",
                  {dangerMode: true}
              );
              return;
            }

            if (
                this.classificationPlan[i].item &&
                this.classificationPlan[i].item.length > 0
            ) {
              this.$swal(
                  this.$t('text.globals.error'),
                  this.$t(
                      "text.classificationPlan.deleteClassificationPlanEntryContainingChildrenErrorSwal.content"
                  ),
                  "error",
                  {dangerMode: true}
              );
              return;
            }
            this.locallyDeletedClasses = true;
            _this.$store.dispatch('addClassificationPlanDeletedClass', _this.classificationPlan[i].alfrescoId.toString());
            this.classificationPlan.splice(i, 1);

            this.classificationPlan = this.checkChildClassesForClassificationLabelNameDuplicateError(
                this.classificationPlan
            );

            this.$store.dispatch(
                "setClassificationPlan",
                this.classificationPlan
            );
            this.$store.dispatch(
                "setClassificationPlanFiltered",
                this.classificationPlan
            );
            this.selectedClassLabel = "none";
            this.selectedClass = null;
            return;
          }

          this.classificationPlan[i] = this.deleteClassificationPlanEntryRec(
              this.classificationPlan[i]
          );
        }

        this.$store.dispatch("setClassificationPlan", this.classificationPlan);
        this.$store.dispatch(
            "setClassificationPlanFiltered",
            this.classificationPlan
        );
        this.updateFilterKeys();
        this.selectedClassLabel = "none";
        this.selectedClass = null;
      } else {
        console.log("izberite razred");
      }
    },

    deleteClassificationPlanEntryRec(classificationPlan) {
      for (let i = classificationPlan.item.length - 1; i >= 0; i--) {
        if (
            classificationPlan.item[i].classificationLabel ==
            this.selectedClassLabel
        ) {
          if (classificationPlan.item[i].containsRecords) {
            this.$swal(
                this.$t('text.globals.error'),
                this.$t(
                    "text.classificationPlan.deleteClassificationPlanEntryContainingDocumentsErrorSwal.content"
                ),
                "error",
                {dangerMode: true}
            );
            return classificationPlan;
          }

          if (
              classificationPlan.item[i].item &&
              classificationPlan.item[i].item.length > 0
          ) {
            this.$swal(
                this.$t('text.globals.error'),
                this.$t(
                    "text.classificationPlan.deleteClassificationPlanEntryContainingChildrenErrorSwal.content"
                ),
                "error",
                {dangerMode: true}
            );
            return classificationPlan;
          }

          this.locallyDeletedClasses = true;
          this.$store.dispatch('addClassificationPlanDeletedClass', classificationPlan.item[i].alfrescoId.toString());
          classificationPlan.item.splice(i, 1);

          classificationPlan.item = this.checkChildClassesForClassificationLabelNameDuplicateError(
              classificationPlan.item
          );

          return classificationPlan;
        }
        classificationPlan.item[i] = this.deleteClassificationPlanEntryRec(
            classificationPlan.item[i]
        );
      }

      return classificationPlan;
    },

    checkChildClassesForClassificationLabelNameDuplicateError(
        classificationPlanChildrenArray
    ) {
      if (classificationPlanChildrenArray.length > 0) {
        let childClassificationLabelNames = {};

        for (let i = 0; i < classificationPlanChildrenArray.length; i++) {
          if (
              !childClassificationLabelNames[
                  classificationPlanChildrenArray[i].classificationLabelName
                  ]
          ) {
            childClassificationLabelNames[
                classificationPlanChildrenArray[i].classificationLabelName
                ] = [];
            childClassificationLabelNames[
                classificationPlanChildrenArray[i].classificationLabelName
                ].push(i);
          } else {
            childClassificationLabelNames[
                classificationPlanChildrenArray[i].classificationLabelName
                ].push(i);
          }
        }

        for (let key of Object.keys(childClassificationLabelNames)) {
          if (childClassificationLabelNames[key].length > 1) {
            for (
                let i = 0;
                i < childClassificationLabelNames[key].length;
                i++
            ) {
              /*
                                classificationPlanChildrenArray[
                                    childClassificationLabelNames[key][i]
                                    ].errors.classificationLabelNameDuplicateError = true;
                                    */

              //console.log("nastavimo na true, ker se: ", key , " pojavi ",  childClassificationLabelNames[key].length, "-krat --->", childClassificationLabelNames[key] );
            }
          } else {
            //console.log("damo na false in sicer ", childClassificationLabelNames[key][0]);
            classificationPlanChildrenArray[
                childClassificationLabelNames[key][0]
                ].errors.classificationLabelNameDuplicateError = false;
          }
        }
      }

      return classificationPlanChildrenArray;
    },

    //PREMESTITEV

    // is called when we click on Preklici button on move-modal, if we do not want to submit changes

    dropRoot: function (ev) {
      ev.preventDefault();
      this.setMovesCopy();
      this.moveClassificationLabel = this.movingClass.classificationLabel;
      if (this.movingClass.parentClass === "none") {
        this.$bvModal.show("modal-error-move");
      } else {
        if (this.movingClass.containsRecords) {
          // if (this.$globalFunctions.checkUserRole("ALFRESCO_ADMIN")) {
          //     this.$swal({
          //         title: this.$t('text.globals.warningTitle'),
          //         text: this.$t(
          //             "text.classificationPlan.moveClassificationPlanEntryContainingDocumentsErrorSwal.content"
          //         ),
          //         dangerMode: true,
          //         buttons: {
          //             cancel: {
          //                 text: this.$t("text.globals.cancel"),
          //                 value: null,
          //                 visible: true,
          //                 className: "",
          //                 closeModal: true
          //             },
          //             confirm: {
          //                 text: this.$t(
          //                     "text.globals.move"
          //                 ),
          //                 value: true,
          //                 visible: true,
          //                 className: "",
          //                 closeModal: true
          //             }
          //         }
          //     }).then(value => {
          //         switch (value) {
          //             case true:
          //                 this.makeMovePreviewRoot();
          //                 console.log(this.movePreview);
          //                 this.$bvModal.show("modal-moveToRoot");
          //
          //             case null:
          //                 return;
          //
          //                 break;
          //
          //             default:
          //         }
          //     });
          // } else {
          this.$swal(
              this.$t('text.globals.error'),
              this.$t(
                  "text.classificationPlan.movingClassContainsRecordsNoAdminErrorSwal.content"
              ),
              "error",
              {dangerMode: true}
          );
          // }
        } else {
          this.makeMovePreviewRoot();
          console.log(this.movePreview);
          this.$bvModal.show("modal-moveToRoot");
        }
      }
      this.draggedOver = false;
    },
    setMovesCopy() {
      this.movesCopy = _.cloneDeep(this.moves);
    },

    cancelMove() {
      let classificationPlan = _.cloneDeep(this.classificationPlanCopy);
      this.$store.dispatch("setClassificationPlan", classificationPlan);
      this.$store.dispatch("setClassificationPlanFiltered", classificationPlan);
      this.moves = _.cloneDeep(this.movesCopy);
      this.classificationPlan = classificationPlan;
    },

    resetReason() {
      this.reasonMissing = false;
      this.moveReason = "";
      this.moveClassificationLabel = "";
    },

    validateMoveToRoot() {
      //console.log("this.reason ", this.moveReason);
      if (this.moveReason == "") {
        this.reasonMissing = true;
      }

      if (this.moveReason != "" && this.moveClassificationLabel != "") {
        this.classificationPlanLabels = [];
        this.updateClassificationPlanLabels();
        console.log("UPDATED LABELS", this.classificationPlanLabels);
        if (
            this.classificationPlanLabels.includes(
                this.moveClassificationLabel
            ) &&
            this.moveClassificationLabel !== this.movingClass.classificationLabel
        ) {
          console.log("Napaka, label ze obstaja");
          this.$bvModal.show("modal-duplicates-error");
        } else {
          this.$bvModal.hide("modal-moveToRoot");
          this.moveToRoot(this.movePayload);
        }
      }
    },

    validateMove() {
      //console.log("this.reason ", this.moveReason);
      if (this.moveReason == "") {
        this.reasonMissing = true;
      }

      if (this.moveReason !== "" && this.moveClassificationLabel !== "") {
        if (this.moveParentLabel === "none") {
          this.$bvModal.hide("modal-moveReason");
          this.moveClass(this.movePayload);
        } else {
          console.log(
              "TEST LABEL",
              this.moveClassificationLabel > this.moveParentLabel &&
              this.moveClassificationLabel.startsWith(this.moveParentLabel)
          );
          if (
              this.moveClassificationLabel > this.moveParentLabel &&
              this.moveClassificationLabel.startsWith(this.moveParentLabel)
          ) {
            this.classificationPlanLabels = [];
            this.updateClassificationPlanLabels();
            if (
                this.classificationPlanLabels.includes(
                    this.moveClassificationLabel
                ) &&
                this.moveClassificationLabel !==
                this.movingClass.classificationLabel
            ) {
              console.log("NAPAKA, LABEL ZE OBSTAJA");
              this.$bvModal.show("modal-duplicates-error");
            } else {
              this.$bvModal.hide("modal-moveReason");
              this.moveClass(this.movePayload);
            }
          } else {
          }
        }
      }
    },

    // sets copy of the classificationPlan before any changes being made

    updateClassificationPlanLabels() {
      let classificationPlan = [];
      classificationPlan = _.cloneDeep(this.classificationPlan);
      for (let i = 0; i < classificationPlan.length; i++) {
        this.updateClassificationPlanLabelsRec(classificationPlan[i]);
      }
      console.log("LABELS ARE: ", this.classificationPlanLabels);
    },

    updateClassificationPlanLabelsRec(classificationPlan) {
      this.classificationPlanLabels.push(
          classificationPlan.classificationLabel
      );
      for (let i = 0; i < classificationPlan.item.length; i++) {
        this.updateClassificationPlanLabelsRec(classificationPlan.item[i]);
      }
    },

    setClassificationPlanCopy() {
      this.classificationPlanCopy = _.cloneDeep(this.classificationPlan);
    },

    // is called when we drop one treeItem onto another treeItem, the event listener in mounted() triggers it
    // sets newParent ..... new parent of the class we want to move and movingClass ..... class we are moving
    // checks if the move is valid (with function checkMove)
    // it deletes class we want to move from old parent, then adds it to new parent
    // dispatches plan

    moveClass(payload) {
      let newParent = payload[0];
      let movingClass = payload[1];
      let oldLabel = movingClass.classificationLabel;
      let oldParent = movingClass.parentClass;
      let newLabel = this.moveClassificationLabel;
      //movingClass.errors.classificationLabel.valueError = true;
      console.log(
          "MOVING CLASS " +
          movingClass.classificationLabel + '(UUID:' + movingClass.alfrescoId + ')' +
          " TO CLASS " +
          newParent.classificationLabel
      );
      let classificationPlan = this.$store.getters.getClassificationPlan;
      let move = {
        reason: this.moveReason,
        oldClassificationLabel: oldLabel,
        newClassificationLabel: newLabel,
        oldParentClass: oldParent,
        newParent: newParent,
        uuid: movingClass.alfrescoId,
        classificationLabelName: movingClass.classificationLabelName
      };
      this.moves.push(move);
      classificationPlan = this.deleteClassFromParent(
          classificationPlan,
          movingClass
      );
      movingClass.classificationLabel = this.moveClassificationLabel;
      for (let i = 0; i < movingClass.item.length; i++) {
        movingClass.item[i].parentClass = movingClass.classificationLabel;
      }

      movingClass = this.addChangedAndOpenFlagToMovingClassRec(movingClass);

      classificationPlan = this.addClassToNewParent(
          classificationPlan,
          newParent,
          movingClass
      );
      this.updateClassificationLabelErrors(movingClass);
      this.$store.dispatch("setClassificationPlan", classificationPlan);
      this.$store.dispatch("setClassificationPlanFiltered", classificationPlan);
      this.$store.dispatch('setMoves', this.moves);
      this.updateFilterKeys();
      console.log("Class moved", classificationPlan);
      this.toggleCollapseAll(true);
    },

    addChangedAndOpenFlagToMovingClassRec(movingClass) {
      movingClass.structure.changed = true;
      movingClass.structure.isOpen = true;

      for (let i = 0; i < movingClass.item.length; i++) {
        movingClass.item[i] = this.addChangedAndOpenFlagToMovingClassRec(
            movingClass.item[i]
        );
      }

      return movingClass;
    },

    //updates the errors caused by wrong labels

    updateClassificationLabelErrors(classificationPlan) {
      if (classificationPlan.parentClass !== "none") {
        if (
            classificationPlan.classificationLabel.startsWith(
                classificationPlan.parentClass
            ) &&
            classificationPlan.classificationLabel.length >
            classificationPlan.parentClass.length
        ) {
          classificationPlan.errors.classificationLabel.valueError = false;
          for (let i = 0; i < classificationPlan.item.length; i++) {
            this.updateClassificationLabelErrors(classificationPlan.item[i]);
          }
        } else {
          classificationPlan.errors.classificationLabel.valueError = true;
          classificationPlan = this.updateClassificationLabelErrorsChildren(
              classificationPlan
          );
        }
      } else {
        classificationPlan.errors.classificationLabel.valueError = false;
        for (let i = 0; i < classificationPlan.item.length; i++) {
          this.updateClassificationLabelErrors(classificationPlan.item[i]);
        }
      }
    },

    updateClassificationLabelErrorsChildren(classificationPlan) {
      classificationPlan.errors.classificationLabel.valueError = true;
      for (let i = 0; i < classificationPlan.item.length; i++) {
        classificationPlan.item[
            i
            ] = this.updateClassificationLabelErrorsChildren(
            classificationPlan.item[i]
        );
      }

      return classificationPlan;
    },

    //makes a preview of the move commited, which is submitted if we save it and reverted if we reject it

    makeMovePreview(payload) {
      let newParent = _.cloneDeep(payload[0]);
      let movingClass = _.cloneDeep(payload[1]);
      //movingClass.errors.classificationLabel.valueError = true;
      console.log(
          "MOVING CLASS " +
          movingClass.classificationLabel +
          " TO CLASS " +
          newParent.classificationLabel
      );
      let classificationPlan = _.cloneDeep(this.classificationPlan);
      classificationPlan = this.deleteClassFromParent(
          classificationPlan,
          movingClass
      );
      movingClass.classificationLabel = this.moveClassificationLabel;
      classificationPlan = this.addClassToNewParent(
          classificationPlan,
          newParent,
          movingClass
      );
      classificationPlan = this.checkDepth(classificationPlan);
      this.movePreview = classificationPlan;
    },

    makeMovePreviewRoot() {
      let movingClass = this.movingClass;
      let classificationPlan = _.cloneDeep(this.classificationPlan);
      classificationPlan = this.deleteClassFromParent(
          classificationPlan,
          movingClass
      );
      classificationPlan.push(movingClass);
      this.movePreview = classificationPlan;
    },

    //todo: to je testni del za premikanje razredov direktno pod root, verjetno bomo html element zamenjali, funkcije pa ostanejo

    // function, that moves class to root

    moveToRoot: function () {
      let classificationPlan = this.$store.getters.getClassificationPlan;
      let oldLabel = this.movingClass.classificationLabel;
      let oldParent = this.movingClass.parentClass;
      let newParent = "none";
      let newLabel = this.moveClassificationLabel;
      let movingClass = this.movingClass;
      //console.log(movingClass);
      this.movingClass.structure["depth"] = 1;
      console.log("PARENT CLASS", movingClass.parentClass);
      if (movingClass.parentClass !== "none") {
        //this.movingClass.classificationLabel = this.moveClassificationLabel;
        let move = {
          reason: this.moveReason,
          oldClassificationLabel: oldLabel,
          newClassificationLabel: newLabel,
          oldParentClass: oldParent,
          newParent: newParent,
          uuid: this.movingClass.alfrescoId,
          classificationLabelName: newLabel
        };
        this.moves.push(move);
        classificationPlan = this.deleteClassFromParent(
            classificationPlan,
            movingClass
        );
        movingClass.parentClass = "none";
        movingClass.classificationLabel = this.moveClassificationLabel;
        for (let i = 0; i < movingClass.item.length; i++) {
          movingClass.item[i].parentClass = movingClass.classificationLabel;
        }
        movingClass = this.addChangedAndOpenFlagToMovingClassRec(movingClass);

        classificationPlan.push(movingClass);
        this.updateClassificationLabelErrors(movingClass);
        this.$store.dispatch("setClassificationPlan", classificationPlan);
        this.$store.dispatch(
            "setClassificationPlanFiltered",
            classificationPlan
        );
      } else {
        this.$bvModal.show("modal-error-move");
      }
    },

    dragoverRoot: function (ev) {
      ev.preventDefault();
      this.draggedOver = true;
    },

    dragleaveRoot: function (ev) {
      ev.preventDefault();
      this.draggedOver = false;
    },

    // checks move if it is legit (can't move parent to one of its children etc)

    checkMove(newParent, movingClass) {
      //console.log("CHECKING MOVE");
      let isLegit = true;
      for (let i = 0; i < movingClass.item.length; i++) {
        isLegit = this.checkMoveRec(
            newParent,
            movingClass,
            movingClass.item[i]
        );
        if (isLegit === false) {
          return isLegit;
        }
      }
      return isLegit;
    },

    checkMoveRec(newParent, movingClass, childObject) {
      //console.log("check move", childObject.classificationLabel, newParent.classificationLabel);
      let isLegit = true;
      if (childObject.classificationLabel === newParent.classificationLabel) {
        return false;
      } else {
        for (let i = 0; i < childObject.item.length; i++) {
          isLegit = this.checkMoveRec(
              newParent,
              movingClass,
              childObject.item[i]
          );
          if (isLegit === false) {
            return isLegit;
          }
        }
      }

      return isLegit;
    },

    // deletes class from parent

    deleteClassFromParent(classificationPlan, movingClass) {
      let parentLabel = movingClass.parentClass;
      //console.log(parentLabel);
      if (parentLabel === "none") {
        for (let i = 0; i < classificationPlan.length; i++) {
          if (
              movingClass.classificationLabel ===
              classificationPlan[i].classificationLabel
          ) {
            classificationPlan.splice(i, 1);
            return classificationPlan;
          }
        }
      }
      for (let i = 0; i < classificationPlan.length; i++) {
        if (classificationPlan[i].classificationLabel === parentLabel) {
          if (classificationPlan[i].item != null) {
            for (let j = 0; j < classificationPlan[i].item.length; j++) {
              if (
                  classificationPlan[i].item[j].classificationLabel ===
                  movingClass.classificationLabel
              ) {
                classificationPlan[i].item.splice(j, 1);
                return classificationPlan;
              }
            }
          }
        } else {
          classificationPlan[i] = this.deleteClassFromParentRec(
              classificationPlan[i],
              movingClass
          );
        }
      }
      return classificationPlan;
    },

    deleteClassFromParentRec(classificationPlan, movingClass) {
      let parentLabel = movingClass.parentClass;
      if (classificationPlan.item != null) {
        for (let i = 0; i < classificationPlan.item.length; i++) {
          if (classificationPlan.item[i].classificationLabel === parentLabel) {
            for (let j = 0; j < classificationPlan.item[i].item.length; j++) {
              if (
                  classificationPlan.item[i].item[j].classificationLabel ===
                  movingClass.classificationLabel
              ) {
                classificationPlan.item[i].item.splice(j, 1);
                return classificationPlan;
              }
            }
          } else {
            classificationPlan.item[i] = this.deleteClassFromParentRec(
                classificationPlan.item[i],
                movingClass
            );
          }
        }
      }

      return classificationPlan;
    },

    // add class to new parent

    addClassToNewParentRec(classificationPlan, newParent, movingClass) {
      if (classificationPlan.item != null) {
        for (let i = 0; i < classificationPlan.item.length; i++) {
          if (
              classificationPlan.item[i].classificationLabel ===
              newParent.classificationLabel
          ) {
            if (classificationPlan.item[i].item != null) {
              movingClass.parentClass =
                  classificationPlan.item[i].classificationLabel;
              classificationPlan.item[i].item.push(movingClass);
            } else {
              let item = [];
              movingClass.parentClass =
                  classificationPlan.item[i].classificationLabel;
              item.push(movingClass);
              classificationPlan.item[i]["item"] = item;
            }
          } else {
            classificationPlan.item[i] = this.addClassToNewParentRec(
                classificationPlan.item[i],
                newParent,
                movingClass
            );
          }
        }
      }

      return classificationPlan;
    },

    //priredi razred novemu starsu

    addClassToNewParent(classificationPlan, newParent, movingClass) {
      for (let i = 0; i < classificationPlan.length; i++) {
        if (
            classificationPlan[i].classificationLabel ===
            newParent.classificationLabel
        ) {
          if (classificationPlan[i].item != null) {
            movingClass.parentClass = newParent.classificationLabel;
            classificationPlan[i].item.push(movingClass);
            return classificationPlan;
          } else {
            let item = [];
            movingClass.parentClass = newParent.classificationLabel;
            item.push(movingClass);
            classificationPlan.item = item;
          }
        } else {
          classificationPlan[i] = this.addClassToNewParentRec(
              classificationPlan[i],
              newParent,
              movingClass
          );
        }
      }
      return classificationPlan;
    },

    // EXPORT, PRINT CHECKBOXES

    // changes checked field, when you pick items for export or printing (checkbox)

    //check argument tells us whether to check or uncheck all
    checkAll(check) {
      let classificationPlan = this.$store.getters.getClassificationPlanFiltered;
      for (let i = 0; i < classificationPlan.length; i++) {
        classificationPlan[i] = this.checkAllRec(classificationPlan[i], check);

      }
      this.$store.dispatch("setClassificationPlanFiltered", classificationPlan);

    },


    checkAllRec(classificationPlan, check) {
      // console.log(classificationPlan);
      classificationPlan.structure.checked = check;
      for (let i = 0; i < classificationPlan.item.length; i++) {
        classificationPlan.item[i] = this.checkAllRec(classificationPlan.item[i], check);
      }

      return classificationPlan;

    },

    changeThis(item) {
      let initialChecked = item.structure.checked;
      //console.log("change this", item);
      let classificationPlan = this.$store.getters
          .getClassificationPlanFiltered;
      let array = [];
      for (let i = 0; i < classificationPlan.length; i++) {
        classificationPlan[i] = this.changeThisRec(item, classificationPlan[i]);
      }
      if (initialChecked === false) {
        classificationPlan = this.changeThisParent(item, classificationPlan);
      }

      this.$store.dispatch("setClassificationPlanFiltered", classificationPlan); //
      this.classificationPlanExport = classificationPlan;
    },

    changeThisRec(item, classificationPlan) {
      if (classificationPlan.classificationLabel === item.classificationLabel) {
        let value = classificationPlan.structure.checked;
        value = !value;
        classificationPlan.structure.checked = value;
        classificationPlan = this.changeThisChildren(classificationPlan, value);
        return classificationPlan;
      } else {
        for (let i = 0; i < classificationPlan.item.length; i++) {
          classificationPlan.item[i] = this.changeThisRec(
              item,
              classificationPlan.item[i]
          );
        }
      }
      return classificationPlan;
    },

    // changes checked field according to the parent, if we set parent to true, children become true, if we set to false, children also become false;
    // convenient if there are lots of children

    changeThisChildren(classificationPlan, value) {
      for (let i = 0; i < classificationPlan.item.length; i++) {
        classificationPlan.item[i] = this.changeChildrenRec(
            classificationPlan.item[i],
            value
        );
      }
      return classificationPlan;
    },

    changeChildrenRec(classificationPlan, value) {
      //console.log("changing children to value ", value,  classificationPlan.classificationLabel);
      classificationPlan.structure.checked = value;
      for (let i = 0; i < classificationPlan.item.length; i++) {
        classificationPlan.item[i] = this.changeChildrenRec(
            classificationPlan.item[i],
            value
        );
      }

      return classificationPlan;
    },

    // if we check a class, the parent chain also has to be checked, we cannot export or print only subfolders without its parents

    changeThisParent(item, classificationPlan) {
      //console.log("change parent, item", item);
      if (item.parentClass === "none") {
        //console.log("pridemo v none");
        return classificationPlan;
      }
      for (let i = 0; i < classificationPlan.length; i++) {
        let array = this.changeThisParentRec(item, classificationPlan[i]);
        classificationPlan[i] = array[0];
        if (array[1] === true) {
          //console.log("return ", classificationPlan);
          return classificationPlan;
        }
      }
      //console.log("return ", classificationPlan);
      return classificationPlan;
    },

    changeThisParentRec(item, classificationPlan) {
      if (classificationPlan.classificationLabel === item.parentClass) {
        classificationPlan.structure.checked = true;
        let array = [classificationPlan, true];
        //console.log("return ", array[0].classificationLabel);
        return array;
      } else {
        for (let i = 0; i < classificationPlan.item.length; i++) {
          let array = this.changeThisParentRec(
              item,
              classificationPlan.item[i]
          );
          if (array[1] === true) {
            classificationPlan.structure.checked = true;
            //console.log("return", array[0].classificationLabel);
            classificationPlan.item[i] = array[0];
            array[0] = classificationPlan;
            return array;
          }
          classificationPlan.item[i] = array[0];
        }
        let array1 = [classificationPlan, false];
        //console.log("return ", array1[0].classificationLabel);
        return array1;
      }
    },

    toggleCollapseAll(forceExpand) {
      const _this = this;

      console.log("forceExpand !!!!!!!!!!!!!!!!!!", forceExpand);
      if (typeof forceExpand !== 'undefined' && forceExpand) {
        _this.collapsed = false;
        console.log("here 1");
      } else {
        _this.collapsed = !_this.collapsed;
        console.log("here 2");
      }

      for (let i = 0; i < _this.classificationPlan.length; i++) {
        _this.classificationPlan[i].structure.isOpen = !_this.collapsed;
      }

      _this.$store.dispatch("setClassificationPlan", _this.classificationPlan);
    },

    moveClassInClassificationPlan() {
      const _this = this;

      _this.$bvModal.show("modal-move");
      _this.setClassificationPlanCopy();
    },

    moveClassByParentSelect() {
      const _this = this;

      if (_this.selectedClassLabel === "none") {
        swal(
            this.$t("text.classificationPlan.noClassSelectedSwal.title"),
            this.$t("text.classificationPlan.noClassSelectedSwal.prompt"),
            "error",
            {dangerMode: true}
        );
        return;
      }

      if (_this.selectedClass.containsRecords) {
        this.$swal(
            this.$t('text.globals.error'),
            this.$t(
                "text.classificationPlan.movingClassContainsRecordsNoAdminErrorSwal.content"
            ),
            "error",
            {dangerMode: true}
        );
        return;
      }

      _this.isLoading = true;

      _this.$bvModal.hide("modal-moveClassOptions");
      _this.selectParentClassModalVisible = true;
      _this.$bvModal.show("modal-selectParentClass");

      _this.setClassificationPlanCopy();

      _this.isLoading = false;
    },

    confirmMoveCall() {
      const _this = this;

      if (_this.newParentClass === null) {
        swal(
            this.$t("text.classificationPlan.newParentClassNotSelectedSwal.title"),
            this.$t("text.classificationPlan.newParentClassNotSelectedSwal.prompt"),
            "error",
            {dangerMode: true}
        );
        return;
      }

      _this.selectParentClassModalVisible = false;
      _this.$bvModal.hide("modal-selectParentClass");

      _this.setClassificationPlanCopy();

      // console.log("_this.newParentClass", _this.newParentClass);
      // console.log("_this.selectedClassLabel", _this.selectedClassLabel);
      // console.log("_this._getClassificationPlan", _this._getClassificationPlan);
      let classificationPlan = _this._getClassificationPlan;

      // izbira ROOT folderja
      if (_this.newParentClass === "none") {
        this.movingClass = _this.selectedClass;
        this.setMovesCopy();
        this.moveClassificationLabel = _this.selectedClassLabel;
        if (this.movingClass.parentClass === "none") {
          this.$bvModal.show("modal-error-move");
        } else {
          if (this.movingClass.containsRecords) {
            if (this.$globalFunctions.checkUserRole("ALFRESCO_ADMIN")) {
              this.$swal({
                title: this.$t('text.globals.warningTitle'),
                text: this.$t(
                    "text.classificationPlan.moveClassificationPlanEntryContainingDocumentsErrorSwal.content"
                ),
                dangerMode: true,
                buttons: {
                  cancel: {
                    text: this.$t("text.globals.cancel"),
                    value: null,
                    visible: true,
                    className: "",
                    closeModal: true
                  },
                  confirm: {
                    text: this.$t(
                        "text.globals.move"
                    ),
                    value: true,
                    visible: true,
                    className: "",
                    closeModal: true
                  }
                }
              }).then(value => {
                switch (value) {
                  case true:
                    this.makeMovePreviewRoot();
                    console.log(this.movePreview);
                    this.$bvModal.show("modal-moveToRoot");

                  case null:
                    return;

                    break;

                  default:
                }
              });
            } else {
              this.$swal(
                  this.$t('text.globals.error'),
                  this.$t(
                      "text.classificationPlan.movingClassContainsRecordsNoAdminErrorSwal.content"
                  ),
                  "error",
                  {dangerMode: true}
              );
            }
          } else {
            this.makeMovePreviewRoot();
            console.log(this.movePreview);
            this.$bvModal.show("modal-moveToRoot");
          }
        }
        this.draggedOver = false;

        // izbira drugih folderjev
      } else {
        console.log("classificationPlan", classificationPlan);
        console.log("newParentClass", _this.newParentClass);

        let filtrate = _.findDeep(classificationPlan, {'classificationLabel': _this.newParentClass}, {childrenPath: 'item'});
        console.log(filtrate.value);


        let payload = [
          filtrate.value, _this.selectedClass
        ];

        console.log("payload", payload);
        console.log("classificationPlan", classificationPlan);

        this.movingClass = payload[1];
        this.moveParentLabel = payload[0].classificationLabel;

        this.moveClassificationLabel = this.movingClass.classificationLabel;

        this.movePayload = payload;
        this.movesCopy = _.cloneDeep(this.moves);
        console.log(
            "move",
            this.movingClass.parentClass === payload[0].classificationLabel,
            this.movingClass.classificationLabel ===
            payload[0].classificationLabel,
            this.checkMove(payload[0], this.movingClass)
        );

        if (
            this.movingClass.classificationLabel !==
            payload[0].classificationLabel
        ) {
          if (
              this.movingClass.parentClass === payload[0].classificationLabel ||
              this.movingClass.classificationLabel ===
              payload[0].classificationLabel ||
              this.checkMove(payload[0], this.movingClass) === false
          ) {
            this.$bvModal.show("modal-error-move");
          } else {
            if (this.movingClass.containsRecords) {
              console.log("contains records");
              if (this.$globalFunctions.checkUserRole("ALFRESCO_ADMIN")) {
                this.$swal({
                  title: this.$t('text.globals.warningTitle'),
                  text: this.$t(
                      "text.classificationPlan.movingClassContainsRecordsSwal.content"
                  ),
                  dangerMode: true,
                  buttons: {
                    cancel: {
                      text: this.$t("text.globals.cancel"),
                      value: null,
                      visible: true,
                      className: "",
                      closeModal: true
                    },
                    confirm: {
                      text: this.$t(
                          "text.globals.move"
                      ),
                      value: true,
                      visible: true,
                      className: "",
                      closeModal: true
                    }
                  }
                }).then(value => {
                  switch (value) {
                    case true:
                      console.log(
                          this.movingClass.classificationLabel,
                          payload[0].classificationLabel,
                          this.checkMove(payload[0], this.movingClass)
                      );
                      this.makeMovePreview(payload);
                      this.$bvModal.show("modal-moveReason");

                    case null:
                      return;

                      break;

                    default:
                  }
                });
              } else {
                this.$swal(
                    this.$t('text.globals.error'),
                    this.$t(
                        "text.classificationPlan.moveClassificationPlanEntryContainingDocumentsErrorSwal.content"
                    ),
                    "error",
                    {dangerMode: true}
                );
              }
            } else {
              console.log(
                  this.movingClass.classificationLabel,
                  payload[0].classificationLabel,
                  this.checkMove(payload[0], this.movingClass)
              );
              this.makeMovePreview(payload);
              this.$bvModal.show("modal-moveReason");
            }
          }
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/ClassificationPlan.vue